// ArChat Layout Fix
// Created: 12-03-2026 17:33:56
// Author: SIVOL® - Aldo Frias - Argentina

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsRu = {
                'login.title': 'Войти',
                'login.slogan': 'Разговоры без границ!',
                'login.username': 'Имя пользователя',
                'login.password': 'Пароль',
                'login.submit': 'Войти',
                'login.loading': 'Загрузка...',
                'login.autoRegister.title': 'Автоматическая регистрация',
                'login.autoRegister.description': 'Если у вас нет аккаунта, введите ваше имя пользователя и пароль. Он будет создан автоматически.',
                'login.forgotPassword': 'Забыли пароль?',
                'login.passwordRecovery.title': 'Восстановление пароля',
                'login.passwordRecovery.description': 'Введите ваш email, чтобы получить ссылку для восстановления.',
                "login.passwordRecovery.emailLabel": "Электронная почта",
                'login.passwordRecovery.emailPlaceholder': 'Введите ваш email',
                'login.passwordRecovery.emailHelp': 'Ссылка для восстановления будет отправлена на ваш email',
                'login.passwordRecovery.send': 'Отправить',
                'login.passwordRecovery.success': 'Ссылка для восстановления отправлена на ваш email. Проверьте свою почту.',
                'login.passwordRecovery.successTitle': 'Письмо отправлено',
                'login.passwordRecovery.successMessage': 'Мы отправили вам письмо с инструкциями по сбросу пароля.\nПроверьте входящие и папку «Спам». Ссылка может прийти с задержкой в несколько минут.',
                'login.passwordRecovery.devExplanation': 'В режиме разработки письмо не отправляется в вашу почту; оно сохраняется для предпросмотра. Используйте «Просмотр письма», чтобы увидеть содержимое и ссылку для восстановления.',
                'login.passwordRecovery.devSinkNotice': '⚠️ Режим разработки: это письмо НЕ было отправлено в вашу почту. Используйте «Просмотр письма», чтобы открыть сгенерированное сообщение и ссылку.',
                'login.passwordRecovery.invalidEmail': 'Пожалуйста, введите действительный адрес электронной почты',
                'login.error.invalidPassword': 'Неверный пароль',
                'common.language': 'Язык',
                'common.loading': 'Загрузка…',
                'common.back': 'Назад',
                'common.backToStart': 'Вернуться на главную',
                'common.changeUser': 'Сменить пользователя',
                'common.request_id_label': 'ID запроса',
                'login.email.invalid': 'Введите действительный адрес электронной почты',
                'captcha.solve': 'Пожалуйста, решите CAPTCHA правильно',
                'captcha.generateError': 'Ошибка генерации CAPTCHA. Перезагрузите страницу.',
                'auth.require_email': 'Для завершения регистрации требуется email. Введите ваш email.',
                'auth.invalid_credentials': 'Неверное имя пользователя или пароль.',
                'auth.account_blocked': 'Аккаунт неактивен. Введите email для активации.',
                'auth.device_limit_reached': 'Достигнут лимит устройств. Выйдите на другом устройстве или обновите план.',
                'auth.login.device_limit.title': 'Достигнут лимит сессий или устройств',
                'auth.login.device_limit.body': 'Ваш тариф ограничивает число одновременно активных сессий или устройств. Чтобы войти, выйдите на другом устройстве или завершите другую активную сессию и повторите попытку.',
                'auth.password_incorrect': 'Неверный пароль.',
                'auth.login.password_error_title': 'Неверный пароль',
                'auth.login.password_attempts_hint': 'У вас есть 3 попытки, чтобы правильно ввести пароль. Если вы их превысите, нужно будет сбросить пароль.',
                'auth.login.password_attempts_exhausted_title': 'Достигнут лимит попыток',
                'auth.login.password_attempts_exhausted_body': 'Вы превысили 3 допустимые попытки. Чтобы продолжить, сбросьте пароль через «Забыли пароль?».',
                'auth.login.go_to_reset_password': 'Перейти к сбросу пароля',
                'auth.login.password_remaining_two': 'У вас осталось 2 попытки.',
                'auth.login.password_remaining_one': 'У вас осталась 1 попытка.',
                'auth.login.password_attempts_locked_inline': 'Достигнуто максимальное число попыток. Необходимо сбросить пароль.',
                'auth.account_inactive_email_mismatch': 'Аккаунт неактивен и email не совпадает.',
                'auth.captcha_failed': 'CAPTCHA неверна. Проверьте ответ.',
                'auth.captcha_expired': 'Срок проверки истёк. Новая сгенерирована автоматически.',
                'auth.unauthorized': 'У вас нет доступа.',
                'auth.generic_error': 'Произошла ошибка. Попробуйте снова.',
                'auth.method_not_allowed': 'Метод не разрешён.',
                'auth.invalid_data': 'Неверные данные.',
                'auth.credentials_required': 'Требуются имя пользователя и пароль.',
                'auth.csrf_invalid': 'Недействительная сессия. Перезагрузите страницу и попробуйте снова.',
                'auth.username_taken': 'Это имя уже занято. Войдите или выберите другое.',
                'auth.username_unavailable': 'Это имя недоступно.',
                'auth.nick_no_spaces': 'Nicknames cannot contain spaces.',
                'auth.password_too_short': 'Пароль должен быть не менее 6 символов.',
                'auth.rate_limit': 'Слишком много попыток. Подождите и попробуйте снова.',
                'auth.confirm_success': 'Аккаунт успешно подтверждён. Перенаправление на вход...',
                'auth.confirm_already_active': 'Ваш аккаунт уже активен. Вы можете войти.',
                'auth.reset_sent': 'Если email зарегистрирован, вы получите инструкции по сбросу пароля.',
                'auth.reset_token_invalid': 'Недействительная или отсутствующая ссылка.',
                'auth.reset_token_expired': 'Срок действия ссылки истёк. Запросите новую в «Забыли пароль?».',
                'auth.reset_done': 'Пароль обновлён. Теперь вы можете войти.',
                'auth.reset_fatal': 'Ошибка сохранения. Попробуйте позже.',
                'auth.password_mismatch': 'Пароли не совпадают.',
                'resetPassword.page.title': 'Новый пароль',
                'resetPassword.page.description': 'Введите новый пароль (не менее 6 символов).',
                'resetPassword.newPassword': 'Новый пароль',
                'resetPassword.newPasswordPlaceholder': 'Не менее 6 символов',
                'resetPassword.submit': 'Сбросить пароль',
                'resetPassword.success': 'Пароль обновлён. Перенаправление на вход...',
                'resetPassword.backToLogin': 'Вернуться к входу',

                'account.delete.section_title': 'Удалить аккаунт',
                'account.delete.description': 'Удаление аккаунта навсегда удалит все ваши данные, сообщения, контакты и настройки. Это действие нельзя отменить.',
                'account.delete.button': 'Удалить мой аккаунт',
                'accountDeletion.title': 'Удаление аккаунта и данных',
                'accountDeletion.description': 'Запросите удаление вашего аккаунта ArChat и связанных данных.',
                'accountDeletion.openRequest': 'Запросить удаление аккаунта и данных',
                'account.delete.confirm_title': 'Удалить аккаунт',
                'account.delete.confirm_message': 'Вы уверены, что хотите удалить аккаунт? На почту будет отправлено письмо с подтверждением. Удаление окончательное и необратимое.',
                'account.delete.email_sent_title': 'Письмо отправлено',
                'account.delete.email_sent': 'Мы отправили письмо с подтверждением. Проверьте входящие и перейдите по ссылке, чтобы подтвердить удаление.',
                'account.delete.error': 'Не удалось обработать запрос. Попробуйте снова.',
                'account.delete.confirm_page_title': 'Подтвердите удаление аккаунта',
                'account.delete.confirm_page_desc': 'Вы собираетесь навсегда удалить аккаунт ArChat. Все данные, сообщения, контакты и настройки будут удалены. Это действие нельзя отменить.',
                'account.delete.confirm_final_button': 'Да, удалить мой аккаунт навсегда',
                'account.delete.cancel_go_back': 'Отменить и вернуться',
                'account.delete.done_title': 'Аккаунт удалён',
                'account.delete.done_message': 'Ваш аккаунт успешно удалён. Все данные удалены.',
                'account.delete_token_expired': 'Ссылка для удаления истекла или недействительна. Запросите новую в профиле.',
                'account.delete_token_invalid': 'Недействительная или отсутствующая ссылка удаления.',
                'account.delete_email_failed': 'Не удалось отправить письмо с подтверждением. Попробуйте позже.',
                'account.delete_error': 'Ошибка при удалении. Попробуйте позже.',

                'auth.register_success_email_sent': 'Аккаунт успешно создан. Отправлено письмо с подтверждением. Проверьте входящие (и папку «Спам») и перейдите по ссылке для активации.',
                'auth.register_success_email_pending': 'Аккаунт создан, но не удалось отправить письмо с подтверждением. Токен активации действителен. Обратитесь к администратору или запросите новое письмо.',
                'auth.email_not_verified': 'Вам нужно подтвердить email для активации аккаунта.',
                'auth.email_not_verified_title': 'Ожидание подтверждения аккаунта',
                'auth.email_send_failed': 'Не удалось отправить email. Попробуйте снова или измените email.',
                'auth.email_send_failed_title': 'Не удалось отправить email',
                'auth.register.email_failed.title': 'Аккаунт создан',
                'auth.register.email_failed.message': 'Ваш аккаунт успешно создан, но при отправке письма подтверждения произошла ошибка. Проверьте папку «Спам» или запросите новое письмо.',
                'auth.register.success.title': 'Аккаунт создан',
                'auth.register.success.message': 'Аккаунт успешно создан. Отправлено письмо с подтверждением. Проверьте входящие (и папку «Спам») и перейдите по ссылке для активации.',
                'auth.resend_sent': 'Письмо с подтверждением отправлено повторно.',
                'auth.resend_email': 'Отправить email снова',
                'auth.retry_resend': 'Повторить',
                'auth.change_email': 'Изменить email',
                'auth.ver_email': 'Просмотр письма',
                'auth.already_verified': 'Аккаунт уже подтверждён.',
                'auth.confirm_email_title': 'Подтвердить email',
                'auth.confirm_email_text': 'Ссылка активации будет отправлена на:',
                'auth.confirm_email_edit': 'Изменить',
                'auth.confirm_email_confirm': 'Подтвердить',
                'auth.confirm_email_typo_hint': 'Вы имели в виду ***@{suggestion}?',
                'brand.slogan': 'Сила быть понятым, независимо от языка',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': 'Сила быть понятым, независимо от языка',
                'home.tagline': 'Обмен сообщениями с автоматическим переводом',
                'home.login': 'Войти',
                'home.register': 'Создать аккаунт',
                'home.language': 'Язык',
                'terms.title': 'Условия использования',
                'terms.accept': 'Принять и Продолжить',
                'terms.reject': 'Отклонить',
                'terms.rejectShort': 'Не принимаю',
                'terms.readAndAccept': 'Я прочитал и принимаю Условия использования',
                'terms.cancel': 'Отмена',
                'register.pageTitle': 'Создать аккаунт',
                'register.pageSubtitle': 'Введите данные для создания аккаунта.',
                'register.submitLabel': 'Создать аккаунт',
                'register.confirm_title': 'Подтвердить аккаунт',
                'register.confirm_message': 'Вы создаёте аккаунт:',
                'register.confirm': 'Подтвердить',
                'register.login_link': 'Уже есть аккаунт?',
                'register.password_hint': 'Минимум 6 символов',
                'register.checking': 'Проверка…',
                'register.username_taken': 'Это имя пользователя уже занято.',
                'register.available': 'Доступно',
                'register.emailAlreadyExists': 'Этот адрес электронной почты уже зарегистрирован.',
                'register.continue': 'Продолжить',
                'login.demo.title': 'Демо-доступ',
                'login.demo.credentials': 'Пользователь: demo / Пароль: demo',
                'captcha.label': 'Проверка безопасности',
                'security.verification_title': 'Проверка безопасности',
                'security.captcha_question': 'Проверочный вопрос',
                'security.enter_answer': 'Введите ответ',
                'captcha.description': 'Решите математическую операцию, чтобы подтвердить, что вы человек',
                'captcha.required': 'Введите ответ CAPTCHA, чтобы продолжить.',
                'menu.conversations': 'Разговоры',
                'menu.contacts': 'Контакты',
                'menu.dashboard': 'Панель управления',
                'menu.profile': 'Мой профиль',
                'menu.settings': 'Настройки',
                'menu.help': 'Помощь',
                'menu.logout': 'Выйти',
                'menu.files': 'Мои файлы',
                'reviews.menu_title': 'Отзывы',
                'reviews.rate_archat': 'Оценить ArChat',
                'reviews.my_review': 'Мой отзыв',
                'navbar.contacts': 'Контакты',
                'navbar.profile': 'Мой профиль',
                'navbar.settings': 'Настройки',
                'navbar.logout': 'Выйти',
                'navbar.status': 'Статус',
                'navbar.users': 'Пользователи',
                'navbar.no_blocked_users': 'Нет заблокированных пользователей',
                'navbar.blocked_users_title': 'Заблокированные пользователи',
                'contacts.blocked_users_title': 'Заблокированные пользователи',
                'contacts.country_label': 'Страна',
                'contacts.not_reported': 'Не указано',
                'navbar.user_fallback': 'Пользователь {id}',
                'onboarding.welcome_title': 'Добро пожаловать в ArChat®',
                'onboarding.welcome_subtitle': 'Общайтесь с кем угодно на любом языке.',
                'onboarding.step1': 'Шаг 1',
                'onboarding.step1_title': 'Шаг 1',
                'onboarding.step1_description': 'Пригласите свой первый контакт',
                'onboarding.step2': 'Шаг 2',
                'onboarding.step2_title': 'Шаг 2',
                'onboarding.step2_description': 'Отправьте свое первое сообщение',
                'onboarding.invite_contact': 'Пригласить контакт',
                'onboarding.explore_archat': 'Изучить ArChat®',
                'help.how_archat_works': 'Как работает ArChat®',
                'help.registration': 'Регистрация',
                'help.private_invitations': 'Приватные приглашения',
                'help.messaging': 'Сообщения',
                'help.security': 'Безопасность',
                'contacts.invite_contact': 'Пригласить контакт',
                'contacts.no_contacts': 'Нет контактов',
                'help.view_initial_guide': 'Показать стартовое руководство',
                'suggestions.title': 'Предложения',
                'suggestions.form.title': 'Заголовок предложения',
                'suggestions.form.message': 'Опишите вашу идею',
                'suggestions.form.submit': 'Отправить предложение',
                'suggestions.send': 'Отправить предложение',
                'suggestions.captcha_placeholder': 'Результат',
                'suggestions.cooldown': 'Вы должны подождать {minutes} минут перед отправкой нового предложения.',
                'suggestions.success_title': 'Предложение отправлено',
                'suggestions.success_message': 'Ваше предложение успешно отправлено. Номер отслеживания: {id}',
                'suggestions.success': 'Спасибо за ваше предложение. Наша команда рассмотрит его.',
                'suggestions.success.title': 'Спасибо за ваше предложение!',
                'suggestions.success.reference': 'Ссылка',
                'suggestions.success.review': 'Наша команда рассмотрит вашу идею.',
                'suggestions.success.email': 'Мы также отправили вам письмо с подтверждением.',
                'suggestions.success.copy': 'Копировать',
                'suggestions.success.copied': 'Ссылка скопирована',
                'suggestions.form.required': 'Заголовок и сообщение обязательны.',
                'suggestions.error': 'Не удалось отправить. Попробуйте снова.',
                'profile.title': 'Мой профиль',
                'profile.founderBadge': 'Основатель #{position}/{limit}',
                'profile.founderTooltip': 'Участник-основатель – Замороженная цена навсегда, пока подписка активна',
                'profile.founderMember': 'Основатель',
                'profile.founderHeaderBadge': '★ Основатель #{position}/150',
                'profile.camera.access_denied': 'Не удалось получить доступ к камере. Проверьте разрешения.',
                'profile.edit': 'Редактировать',
                'profile.save': 'Сохранить изменения',
                'profile.save.success': 'Ваш профиль успешно обновлен.',
                'profile.save.success.title': 'Профиль Обновлен',
                'profile.update.success.title': 'Профиль Обновлен',
                'profile.update.success.message': 'Ваши изменения сохранены.',
                'profile.save.error': 'Не удалось обновить профиль. Пожалуйста, попробуйте снова.',
                'profile.save.error.title': 'Ошибка Сохранения',
                'profile.cancel': 'Отмена',
                'profile.nick': 'Имя пользователя',
                'profile.nick.help': 'Ваш уникальный идентификатор в системе',
                'profile.name': 'Имя',
                'profile.lastname': 'Фамилия',
                'profile.alias': 'Псевдоним',
                "profile.email": "Электронная почта",
                'profile.phone': 'Телефон',
                'profile.language': 'Язык',
                'profile.country': 'Страна',
                "profile.country.select": "Выберите страну",
                'profile.biography': 'Биография',
                'bio.modal.original': 'Оригинал',
                'bio.modal.translation': 'Перевод',
                'bio.modal.empty': 'У этого контакта нет биографии.',
                'bio.modal.translating': 'Перевод...',
                'bio.modal.translation_error': 'Не удалось перевести биографию.',
                'attachment.unnamed_file': 'Файл',
                'auth.login_error.default_title': 'Ошибка доступа',
                'auth.login_error.default_message': 'Не удалось войти.',
                'profile.photo': 'Фото профиля',
                'notifications.bell.aria': 'Уведомления',
                'notifications.panel.title': 'Уведомления',
                'notifications.empty': 'Нет уведомлений',
                'notifications.mark_read': 'Пометить прочитанным при открытии',
                'billing.change_plan': 'Сменить тариф',
                'billing.usage.title': 'Использование плана',
                'billing.usage.users': 'Пользователи',
                'billing.usage.messages': 'Сообщения (сегодня)',
                'billing.usage.invitations': 'Приглашения (сегодня)',
                'billing.usage.messages_month': 'Сообщения за месяц',
                'billing.usage.chats': 'Чаты',
                'billing.usage.warning': 'Вы приближаетесь к лимиту плана. Перейдите на PRO для большей емкости.',
                "plans.limit.reached": "Достигнут предел — улучшить план",
                'profile.theme.dark': 'Темный режим',
                'profile.theme.light': 'Светлый режим',
                'profile.theme.argentina': 'Тема Аргентины',
                'modal.title': 'Заголовок',
                'modal.success.title': 'Успех',
                'modal.error.title': 'Ошибка',
                'modal.warning.title': 'Предупреждение',
                'info.title': 'Информация',
                'appearance.title': 'Внешний вид',
                'appearance.theme.light': 'Светлая',
                'appearance.theme.dark': 'Тёмная',
                'theme.title': 'Тема',
                'theme.light': 'Светлая',
                'theme.dark': 'Тёмная',
                'profile.photo.section': 'Фото профиля',
                'profile.personalInfo': 'Личная информация',
                'profile.preferences': 'Настройки',
                'profile.country.help': 'Часовой пояс будет автоматически назначен в соответствии с выбранной страной',
                'profile.lastname.placeholder': 'Ваша фамилия (необязательно)',
                'profile.name.placeholder': 'Ваше имя (необязательно)',
                'profile.biography.placeholder': 'Расскажите нам о себе...',
                'profile.notifications.sound': 'Звук уведомлений',
                'profile.notifications.sound_desc': 'Воспроизводить звук при получении сообщений или важных уведомлений',
                'profile.plan.title': 'План подписки',
                'profile.plan.current': 'Ваш Текущий План',
                'profile.plan.expires': 'Действует до',
                'profile.plan.loading_info': 'Загрузка информации о плане...',
                'profile.plan.valid_until': 'Действует до:',
                'profile.plan.active_since': 'Активен с:',
                'profile.plan.active_badge': '✓ Активен',
                'profile.plan.free.description': 'Бесплатный план с ограниченными функциями. Обновите до PRO, чтобы наслаждаться всеми функциями без ограничений.',
                'profile.plan.pro.description': 'Отлично! У вас есть полный доступ ко всем премиум-функциям ArChat®.',
                "profile.plan.upgrade.button": "Обновите до PRO",
                'profile.plan.upgrade.hint': 'Access all features without limits',
                'profile.photo.change': 'Изменить фото профиля',
                'message.placeholder': 'Написать сообщение...',
                'message.placeholderWithFile': 'Отправить файл',
                "message.sent_from_country": "Отправлено из",
                "message.sent_at_local_time": "местное время эмитента",
                "message.timezone_label": "часовой пояс",
                "message.context_info": "Это сообщение сохраняет временной контекст того времени, когда оно было отправлено.",
                "message.context_pro_hint": "Это сообщение имеет временной и географический контекст, доступный в планах Pro.",
                "message.context_pro_badge": "Контекст Про",
                'message.audio.transcribe': 'Транскрибировать аудио',
                'message.audio.transcribing': 'Транскрибирование...',
                'message.audio.transcription': 'Транскрипция',
                'message.audio.error': 'Не удалось транскрибировать аудио',
                'attachment.title': 'Прикрепить файл',
                'attachment.close': 'Закрыть',
                'attachment.gallery': 'Галерея фото/видео',
                'attachment.cameraFront': 'Фронтальная камера',
                'attachment.cameraBack': 'Задняя камера',
                'attachment.cameraWeb': 'Веб-камера',
                'attachment.selectFile': 'Выбрать файл (PDF, текст, изображения, видео)',
                'attachment.remove': 'Удалить',
                'attachments.recipientFreeBlocked.title': 'Ограничение тарифа',
                'attachments.recipientFreeBlocked.sender': 'У пользователя тариф Free — вложения получать нельзя.',
                'attachments.recipientFreeBlocked.receiver': '{senderName} пытался отправить вам вложение, но тариф {planName} не принимает вложения. Рекомендуем перейти на более высокий тариф, чтобы получать файлы.',
                'attachments.recipientFreeBlocked.upgradeCta': 'Улучшить тариф',
                'attachment.audioNotSupported': 'Голосовые сообщения несовместимы с ArChat®. Пожалуйста, отправьте текстовое сообщение.',
                'message.audioDeprecated.title': 'Голосовое сообщение несовместимо',
                'message.audioDeprecated.message': 'Это голосовое сообщение больше несовместимо с ArChat®. Пожалуйста, отправьте текстовое сообщение.',
                'camera.title': 'Камера',
                'camera.close': 'Закрыть',
                'camera.switch': 'Переключить камеру',
                'camera.capture': 'Сделать фото',
                'camera.loading': 'Запуск камеры...',
                'camera.retry': 'Повторить',
                'camera.error.access': 'Не удалось получить доступ к камере. Проверьте разрешения.',
                'camera.error.permission': 'Разрешение камеры отклонено. Пожалуйста, разрешите доступ к камере в настройках браузера.',
                'camera.error.notFound': 'Камера не найдена.',
                'camera.error.busy': 'Камера используется другим приложением.',
                'camera.error.constraint': 'Ограничения камеры не могут быть выполнены.',
                'profile.photo.take': 'Сделать фото',
                'profile.photo.gallery': 'Выбрать из галереи',
                'profile.photo.uploading': 'Загрузка изображения...',
                'profile.photo.upload.success': 'Фото профиля успешно обновлено',
                'profile.photo.upload.success.title': 'Фото Обновлено',
                'profile.photo.upload.error': 'Ошибка при загрузке фото профиля. Пожалуйста, попробуйте снова.',
                'profile.photo.upload.error.title': 'Ошибка Загрузки',
                'user.default': 'Пользователь',
                'logout.title': 'Подтвердить',
                'logout.confirm': 'Вы уверены, что хотите выйти?',
                'contacts.title': 'Контакты',
                'contacts.search': 'Поиск контакта',
                'contacts.search.placeholder': 'Поиск по имени пользователя, имени, фамилии, стране или языку...',
                'contacts.sort': 'Сортировать',
                'contacts.sortByName': 'По имени',
                'contacts.sortByStatus': 'По статусу',
                'contacts.sortByRecent': 'Недавние',
                'contacts.filter': 'Фильтр',
                'contacts.filterAll': 'Все',
                'contacts.filterAvailable': 'Доступные',
                'contacts.filterInvited': 'Приглашённые',
                'contacts.filterBlocked': 'Заблокированные',
                'contacts.pending_invitations': 'Ожидающие приглашения',
                'contacts.status.invitation_sent': 'Приглашение отправлено',
                'contacts.empty': 'Нет контактов',
                'contacts.empty.title': 'У вас пока нет контактов',
                'contacts.empty.message': 'Пригласите или добавьте контакт, чтобы начать общение.',
                'contacts.empty.invite_button': 'Пригласить контакт',
                'contacts.empty.private.message': 'Ваш профиль приватный. Пригласите контакты, чтобы начать общаться.',
                'contacts.empty.private.invite_button': 'Пригласить контакт',
                'contacts.search.no_results': 'Контакты не найдены',
                'contacts.search.clear': 'Показать все',
                'contacts.controls.search_placeholder': 'Поиск контакта...',
                'contacts.controls.search_label': 'Поиск контакта',
                'contacts.controls.sort_label': 'Сортировать по',
                'contacts.controls.sort.name': 'Имя',
                'contacts.controls.sort.status': 'Статус',
                'contacts.controls.sort.recent': 'Недавние',
                'contacts.controls.sort.manual': 'Вручную',
                'contacts.controls.sort.manual_drag_hint': 'Перетащите для порядка',
                'contacts.controls.filter_label': 'Статус',
                'contacts.controls.filter.all': 'Все',
                'contacts.controls.filter.available': 'Доступные',
                'contacts.controls.filter.invited': 'Приглашённые',
                'contacts.controls.filter.blocked': 'Заблокированные',
                'contacts.controls.filter.favorites': 'Избранное',
                'contacts.nick': 'Имя пользователя',
                'contacts.name': 'Имя',
                'contacts.lastname': 'Фамилия',
                'contacts.country': 'Страна',
                'contacts.language': 'Язык',
                'contacts.status': 'Статус',
                'status.available': 'Доступен',
                'status.busy': 'Занят',
                'status.in_call': 'На связи',
                'status.away': 'Отошёл',
                'status.offline': 'Не в сети',
                'status.custom': 'Своё сообщение',
                'status.set_title': 'Статус доступности',
                'status.set_button': 'Изменить статус',
                'status.placeholder': 'Необязательное сообщение (напр. На встрече)',
                'contacts.status.pending_registration': 'Ожидает регистрации',
                'contacts.status.registered': 'Приглашён - Зарегистрирован',
                'contacts.status.ready_to_chat': 'Готов к чату',
                'contacts.status.active_conversation': 'Активный разговор',
                'contacts.invitation.pending.title': 'Ожидающее Приглашение',
                'contacts.invitation.pending.message': 'Это приглашение ожидает регистрации. Контакт получит электронное письмо для завершения регистрации. После регистрации вы сможете общаться с ним.',
                'contacts.error.no_registered': 'Контакт еще не зарегистрирован. Дождитесь завершения регистрации.',
                'contact.edit.title': 'Редактировать контакт',
                'contact.edit.alias.label': 'Пользовательский псевдоним',
                'contact.edit.alias.placeholder': 'Например: Иван с работы',
                'contact.edit.alias.help': 'Это имя будет отображаться вместо настоящего имени',
                'contact.edit.nota.label': 'Личная заметка',
                'contact.edit.nota.placeholder': 'Добавьте заметку об этом контакте...',
                'contact.edit.nota.help': 'Приватные заметки видны только вам',
                'contact.edit.error.noUser': 'Ошибка: Пользователь не идентифицирован',
                'contact.edit.error.noContactId': 'Ошибка: Не удалось идентифицировать контакт',
                'contact.edit.error.save': 'Ошибка при сохранении',
                'contact.limit.title': 'Достигнут лимит контактов',
                'contact.limit.message': 'План FREE — до 2 контактов на пользователя. Перейдите на FOUNDATION или PRO для большей ёмкости, когда оплата будет включена.',
                'contact.edit.info.personalized': 'Эти изменения персонализированы только для вас и не влияют на других пользователей.',
                'contact.edit.profileInfo': 'Информация профиля',
                'export.title': 'Экспорт Разговора',
                'export.description': 'Выберите формат, в котором вы хотите экспортировать этот разговор:',
                'export.progress': 'Экспорт...',
                "export.format.pdf": "PDF",
                'export.format.pdf.description': 'PDF документ со всеми изображениями и файлами',
                "export.format.html": "HTML",
                'export.format.html.description': 'HTML файл, который вы можете открыть в любом браузере',
                'export.info': 'Экспорт будет включать все сообщения, изображения и файлы из этого разговора.',
                'export.pro_required.title': 'Экспорт переписки',
                'export.pro_required.message': 'Эта функция доступна в тарифе PRO.',
                'invitation.title': 'Пригласить Контакт по Email',
                'invitation.modal.title': 'Отправить Приглашение',
                'invitation.modal.description': 'Пригласите кого-нибудь пообщаться с вами в ArChat®. Он получит письмо со ссылкой для принятия приглашения.',
                'invitation.email.label': 'Email Приглашенного',
                'invitation.email.placeholder': 'пример@email.com',
                'invitation.email.required': 'Email обязателен',
                'invitation.email.invalid': 'Пожалуйста, введите действительный email',
                'invitation.language.label': 'Предпочитаемый Язык Приглашенного',
                'invitation.language.help': 'Письмо будет отправлено на этом языке',
                'invitation.mode.label': 'Режим Разговора',
                'invitation.mode.profesional': 'Профессиональный',
                'invitation.mode.profesional.description': 'Формальный и профессиональный разговор',
                'invitation.mode.tecnico': 'Технический',
                'invitation.mode.tecnico.description': 'Технический и специализированный разговор',
                'invitation.mode.casual': 'Неформальный',
                'invitation.mode.casual.description': 'Неформальный и дружелюбный разговор',
                'invitation.message.label': 'Личное Сообщение (необязательно)',
                'invitation.message.placeholder': 'Напишите личное сообщение для приглашенного...',
                'invitation.send': 'Отправить Приглашение',
                'invitation.sending': 'Отправка...',
                'invitation.success': 'Приглашение успешно отправлено',
                'invitation.error': 'Ошибка при отправке приглашения',
                'invitation.error.self': 'Вы не можете пригласить себя',
                'invitation.error.duplicate': 'Ожидающее приглашение уже существует для этого email',
                'invitation.list.title': 'Отправленные Приглашения',
                'invitation.list.empty': 'Вы не отправили ни одного приглашения',
                "invitation.list.email": "Электронная почта",
                'invitation.list.language': 'Язык',
                'invitation.list.mode': 'Режим',
                'invitation.list.status': 'Статус',
                'invitation.list.created': 'Отправлено',
                'invitation.list.expires': 'Истекает',
                'invitation.list.actions': 'Действия',
                'invitation.status.pending': 'Ожидает',
                'invitation.status.accepted': 'Принято',
                'invitation.status.expired': 'Истекло',
                'invitation.status.cancelled': 'Отменено',
                'invitation.copy.link': 'Копировать Ссылку',
                'invitation.copy.success': 'Ссылка скопирована в буфер обмена',
                'invitation.cancel': 'Отменить',
                'invitation.cancel.confirm': 'Вы уверены, что хотите отменить это приглашение?',
                'invitation.cancel.success': 'Приглашение успешно отменено',
                'invitation.cancel.title': 'Подтвердить Отмену',
                'invitation.resend': 'Отправить email повторно',
                'invitation.resend.title': 'Повторно Отправить Приглашение',
                'invitation.resend.success': 'Email приглашения успешно отправлен повторно',
                'invitation.resend.error': 'Ошибка при повторной отправке email приглашения',
                'invitation.accept.title': 'Принять Приглашение',
                'invitation.accept.description': 'Вас пригласили пообщаться в ArChat®',
                'invitation.accept.inviter': 'Приглашен',
                'invitation.accept.message': 'Личное сообщение',
                'invitation.accept.login': 'Войти',
                'invitation.accept.register': 'Зарегистрироваться',
                'invitation.accept.error.invalid': 'Недействительный токен приглашения',
                'invitation.accept.error.expired': 'Это приглашение истекло',
                'invitation.accept.error.accepted': 'Это приглашение уже было принято',
                'invitation.accept.error.cancelled': 'Это приглашение было отменено',
                'invitation.accept.error.email_mismatch': 'Email вашего аккаунта не совпадает с email приглашения',
                'invitation.accept.success': 'Приглашение принято. Перенаправление в чат...',
                'invitations.sent.title': 'Отправленные приглашения',
                'invitations.sent.empty': 'Нет ожидающих приглашений',
                'invitations.pending.title': 'Ожидающие приглашения',
                "invitations.columns.email": "Электронная почта",
                'invitations.columns.language': 'Язык',
                'invitations.columns.mode': 'Режим',
                'invitations.columns.status': 'Статус',
                'invitations.columns.sentAt': 'Отправлено',
                'invitations.columns.actions': 'Действия',
                'invitations.status.pending': 'Ожидает',
                'invitations.status.accepted': 'Принято',
                'invitations.status.cancelled': 'Отменено',
                'invitations.status.expired': 'Истекло',
                'invitations.actions.cancel': 'Отменить',
                'invitations.actions.copy': 'Копировать ссылку',
                'invitations.actions.resend': 'Отправить email снова',
                'profile.privacy.title': 'Конфиденциальность',
                'profile.privacy.public_visibility': 'Сделать мой профиль публично видимым',
                'profile.privacy.public_warning': 'Это позволяет любому пользователю ArChat® найти вас и начать разговор.',
                'profile.privacy.private_info': 'Ваш профиль приватный. Только пользователи, которых вы пригласите или которые пригласят вас, смогут общаться с вами.',
                'profile.privacy.private_default': 'По умолчанию ваш профиль приватный для большей безопасности.',
                'common.close': 'Закрыть',
                'common.sending': 'Отправка...',
                'common.cancel': 'Отмена',
                'common.confirm': 'Подтвердить',
                'common.save': 'Сохранить',
                'common.saving': 'Сохранение...',
                'buttons.accept': 'Принять',
                'buttons.cancel': 'Отмена',
                'buttons.save': 'Сохранить',
                'buttons.edit': 'Редактировать',
                'buttons.retry': 'Повторить',
                'buttons.confirm': 'Подтвердить',
                'buttons.yes': 'Да',
                'buttons.no': 'Нет',
                'buttons.send': 'Отправить',
                'buttons.close': 'Закрыть',
                'buttons.continue': 'Продолжить',
                'buttons.delete': 'Удалить',
                'buttons.logout': 'Выйти',
                'buttons.back': 'Назад',
                'buttons.update': 'Обновить',
                'buttons.upload': 'Загрузить',
                'buttons.select': 'Выбрать',
                'conversation.backToContacts': 'Вернуться к контактам',
                'help.title': 'Помощь ArChat®',
                'help.what.title': 'Что такое ArChat®?',
                'help.what.description': 'ArChat® - это система текстовых сообщений с автоматическим переводом, которая позволяет общаться с людьми, которые не говорят на вашем языке, сохраняя ясность, контекст и конфиденциальность с первого сообщения.',
                'help.how.title': 'Как это работает?',
                'help.how.step1.title': 'Войти',
                'help.how.step1.description': 'Используйте свой ник и пароль для доступа к системе. Если у вас нет аккаунта, он будет создан автоматически.',
                'help.how.step2.title': 'Пригласите ваш контакт',
                'help.how.step2.description': 'Пригласите ваш контакт по email из вашего профиля. Определите язык и режим разговора с самого начала.',
                'help.how.step3.title': 'Напишите на вашем языке',
                'help.how.step3.description': 'Напишите ваше сообщение на вашем предпочитаемом языке. Система автоматически переведет написанное сообщение.',
                'help.how.step4.title': 'Другой получает переведенным',
                'help.how.step4.description': 'Получатель получает сообщение автоматически переведенным на его язык, сохраняя ясность и контекст.',
                'help.features.title': 'Основные функции',
                'help.features.translation': '🌐 Автоматический и мгновенный перевод между языками',
                'help.features.status': '💬 Статус присутствия (В сети, Неактивен, Не беспокоить и т.д.)',
                'help.features.statusCustom': '💬 Пользовательские статусы с эмодзи и персонализированным сообщением',
                'help.features.contacts': '👥 Полный список контактов с поиском и фильтрами',
                'help.features.contactsMobile': '📱 Оптимизированный мобильный вид с полной информацией (фамилия, страна, статус)',
                'help.features.contactsFilter': '👁️ Кнопка для показа/скрытия контактов, не являющихся избранными - сокращает список до ваших избранных',
                'help.features.contactAlias': '✏️ Пользовательский псевдоним и приватные заметки для каждого контакта - нажмите на имя контакта в разговоре',
                'help.features.themes': '🎨 Две доступные темы: Аргентина (голубая/белая/золотая) и Темная (темно-фиолетовая)',
                'help.features.messages': '📨 Мгновенные сообщения в реальном времени с индикаторами прочтения',
                'help.features.attachments': '📎 Прикрепление файлов, совместимых с текстовым общением: изображения, видео и PDF документы',
                'help.features.camera': '📸 Фотосъемка с фронтальной, задней камеры или веб-камеры',
                'help.features.gallery': '🖼️ Выбор файлов из галереи',
                'help.features.compression': '🗜️ Автоматическое сжатие изображений и создание миниатюр',
                'help.features.progress': '📊 Индикатор прогресса во время загрузки файлов',
                'help.features.delete': '🗑️ Удаление ваших собственных сообщений',
                'help.features.scroll': '⬇️ Автоматическая прокрутка к последнему сообщению при открытии разговора',
                'help.features.profile': '👤 Настраиваемый профиль с аватаром, биографией и предпочтениями',
                'help.features.profileEdit': '✏️ Редактирование профиля без прерываний (не обновляется во время редактирования)',
                'help.features.countries': '🌍 Полный список из 195+ стран с автоматическим выбором часового пояса',
                'help.features.registration': '📧 Регистрация с подтверждением по email и CAPTCHA безопасности',
                'help.features.multilanguage': '🗣️ Поддержка нескольких языков (Испанский, Английский, Португальский, Французский, Немецкий, Итальянский, Русский, Китайский, Японский, Корейский, Арабский, Хинди)',
                'help.features.pwa': '📲 Устанавливаемое PWA приложение на мобильных устройствах и рабочем столе',
                'help.features.sync': '🔄 Автоматическая синхронизация сообщений каждые 5 секунд',
                'help.features.deleteSync': '🗑️ Автоматическая синхронизация удаленных сообщений между устройствами',
                'help.features.notifications': '🔔 Звуковые уведомления для новых полученных сообщений',
                'help.features.retranslation': '🔄 Автоматическая повторная транскрипция сообщений, если первая попытка не удалась',
                'help.features.preview': '👁️ Предварительный просмотр файлов перед отправкой',
                'help.features.security': '🔒 Система безопасности с CAPTCHA, отпечатком браузера и ограничением скорости',
                'help.features.passwordRecovery': '🔑 Восстановление пароля по email',
                'help.features.emailConfirmation': '📧 Подтверждение аккаунта по email с ссылкой активации',
                'help.features.invitations': '📧 Приватные приглашения по email - Приглашайте внешние контакты с определенным языком и контекстом',
                'help.features.invitationsManagement': '📋 Полное управление приглашениями - Список, повторная отправка или отмена ожидающих приглашений из меню',
                'help.features.contactStatus': '🏷️ Видимый статус контакта - См. статус каждого контакта (ожидает, зарегистрирован, готов к чату)',
                'help.features.favorites': '⭐ Система избранного - Отметьте контакты как избранные для быстрого доступа',
                'help.features.profilePhoto': '📸 Улучшенная загрузка фото профиля - Выберите изображения из галереи с немедленным предпросмотром',
                'help.features.translationSender': '👁️ Просмотр переводов для отправителя - Увидьте, как ваше сообщение было переведено на язык получателя',
                'help.features.unifiedContacts': '🔗 Единая модель контактов - Контакты выводятся из приглашений и существующих разговоров',
                'help.features.privacy': '🔒 Приватный режим по умолчанию - Ваш профиль приватный и доступен только по прямому приглашению',
                'help.features.export': '💾 Экспорт разговоров - Экспортируйте полные разговоры в PDF или HTML с изображениями и файлами',
                'help.tips.title': 'Полезные советы',
                'help.tips.language': '✅ Установите ваш предпочитаемый язык в профиле для получения правильно переведенных сообщений',
                'help.tips.status': '✅ Обновляйте ваш статус присутствия, чтобы другие знали о вашей доступности',
                'help.tips.statusCustom': '✅ Создавайте пользовательские статусы с эмодзи и сообщением для выражения вашего текущего состояния',
                'help.tips.search': '✅ Отмечайте избранные (звезда) и блокируйте пользователей через модальное окно "Пользователи"',
                'help.tips.contactsFilter': '✅ Используйте кнопку глаза (👁️) в верхней панели, чтобы показать или скрыть контакты, которые не являются избранными',
                'help.tips.contactAlias': '✅ Нажмите на имя контакта в разговоре, чтобы добавить пользовательский псевдоним и приватные заметки',
                'help.tips.avatar': '✅ Нажмите на аватар контакта, чтобы увидеть его изображение в большом размере',
                'help.tips.messages': '✅ Иконка ArChat® мигает, когда у вас есть непрочитанные сообщения',
                'help.tips.attachments': '✅ Прикрепляйте изображения, видео или PDF используя кнопку скрепки (📎); совместимо с текстовым общением',
                'help.tips.camera': '✅ Используйте камеру для съемки фотографий прямо из приложения',
                'help.tips.compression': '✅ Изображения автоматически сжимаются для экономии места',
                'help.tips.delete': '✅ Вы можете удалить свои сообщения, нажав кнопку удалить',
                'help.tips.profile': '✅ Редактируйте свой профиль без беспокойства: система не обновляется, пока вы редактируете',
                'help.tips.country': '✅ Выберите вашу страну в профиле, чтобы часовой пояс настроился автоматически',
                'help.tips.registration': '✅ При регистрации подтвердите ваш email для полной активации аккаунта',
                'help.tips.writing': '✅ Пишите ясные сообщения: ArChat® переводит смысл написанного текста, сохраняя контекст и ясность',
                'help.tips.install': '✅ Установите ArChat® как PWA приложение на вашем устройстве для быстрого доступа с рабочего стола',
                'help.tips.sync': '✅ Сообщения автоматически синхронизируются каждые 5 секунд - вам не нужно обновлять',
                'help.tips.deleteSync': '✅ Если вы удалите сообщение, оно будет автоматически удалено на всех устройствах получателя',
                'help.tips.notifications': '✅ Вы услышите звук, когда получите новое сообщение от другого пользователя',
                'help.tips.retranslation': '✅ Если сообщение не было переведено правильно, система попытается автоматически перевести его повторно',
                'help.tips.preview': '✅ Просмотрите предварительный просмотр файла перед отправкой, чтобы убедиться, что это правильный',
                'help.tips.passwordRecovery': '✅ Если вы забыли пароль, используйте ссылку "Забыли пароль?" при входе',
                'help.tips.emailConfirmation': '✅ Проверьте вашу электронную почту после регистрации и нажмите на ссылку подтверждения',
                'help.tips.languageChange': '✅ Измените ваш язык в любое время из селектора флагов - обновляется мгновенно',
                'help.tips.inputFixed': '✅ На ПК панель ввода остается зафиксированной в нижней части экрана для большего удобства',
                'help.tips.invitations': '✅ Приглашайте контакты по email из вашего профиля - Определите язык и режим разговора с самого начала',
                'help.tips.invitationsManagement': '✅ Управляйте своими приглашениями из меню "Отправленные приглашения" - Повторно отправляйте письма или отменяйте ожидающие приглашения',
                'help.tips.contactStatus': '✅ Наблюдайте статус каждого контакта в списке - Ожидает (оранжевый), Зарегистрирован (зеленый) или Активный разговор (синий)',
                'help.tips.favorites': '✅ Отметьте контакты как избранные звездочкой ⭐ - Избранные появляются первыми в вашем списке',
                'help.tips.profilePhoto': '✅ Загрузите фото профиля из "Выбрать из галереи" - Вы увидите предпросмотр перед сохранением',
                'help.tips.translationSender': '✅ При отправке сообщения разверните панель перевода, чтобы увидеть, как оно было переведено на язык получателя',
                'help.tips.unifiedContacts': '✅ Ваши контакты автоматически отображаются, когда они принимают приглашения или у вас есть разговоры с ними',
                'help.tips.privacy': '✅ Ваш профиль приватный по умолчанию - Включите публичную видимость в Профиль > Конфиденциальность, если хотите, чтобы другие вас нашли',
                'help.tips.export': '✅ Экспортируйте полные разговоры, используя кнопку ⬇️ в заголовке - Выберите PDF или HTML со всеми изображениями',
                'help.support.title': 'Поддержка',
                'help.support.description': 'Если у вас есть проблемы или вопросы, свяжитесь с администратором системы или просмотрите доступную техническую документацию.',
                'help.about.title': 'О программе',
                'help.about.developer': 'Разработано:',
                'help.about.location': 'МДК - АРГЕНТИНА',
                'help.about.linkedin': 'Посмотреть профиль LinkedIn',
                'presence.title': 'Статус присутствия',
                'presence.currentStatus': 'Текущий статус:',
                'presence.changeStatus': 'Изменить статус',
                'presence.status.online': 'Онлайн',
                'presence.status.online.title': 'Онлайн - Виден всем',
                'presence.status.online.description': 'Онлайн: Виден всем контактам',
                'presence.status.idle': 'Неактивен',
                'presence.status.idle.title': 'Неактивен - Указывает на временное отсутствие',
                'presence.status.idle.description': 'Неактивен: Указывает, что вы временно недоступны',
                'presence.status.dnd': 'Не беспокоить',
                'presence.status.dnd.title': 'Не беспокоить - Указывает, что вы предпочитаете не отвлекаться',
                'presence.status.dnd.description': 'Не беспокоить: Видимый сигнал, что вы предпочитаете не отвлекаться',
                'presence.status.busy': 'Занят',
                'presence.status.busy.title': 'Занят - Недоступен',
                'presence.status.busy.description': 'Занят: Недоступен',
                'presence.status.offline': 'Офлайн',
                'presence.status.offline.title': 'Отключен - Появляться офлайн',
                'presence.status.offline.description': 'Офлайн: Появляться отключенным',
                'presence.status.custom': 'Пользовательский',
                'presence.status.custom.title': 'Пользовательский - Уникальный статус с эмодзи',
                'presence.status.custom.description': 'Пользовательский: Уникальный статус с эмодзи и опциональным сроком действия',
                'dashboard.title': 'Панель',
                'dashboard.planUsage': 'Использование плана',
                'dashboard.filesSummary': 'Мои файлы',
                'dashboard.promotions': 'Акции',
                'dashboard.sessions': 'Активные сессии',
                'dashboard.explore': 'Обзор',
                'dashboard.noSessions': 'Нет активных сессий',
                'dashboard.welcomeTitle': 'Добро пожаловать в ArChat®',
                'dashboard.welcomeSubtitle': 'Общайтесь на любом языке.',
                'dashboard.stepInvite': 'Шаг 1: пригласите первый контакт',
                'dashboard.stepMessage': 'Шаг 2: отправьте первое сообщение',
                'dashboard.inviteContact': 'Пригласить контакт',
                'dashboard.exploreArChat': 'Открыть ArChat',
                'dashboard.promotionsTitle': 'Акции',
                'dashboard.promotionsText': 'Кратко о реферальной программе и наградах.',
                'dashboard.viewPromotions': 'Смотреть акции',
                'dashboard.usageTitle': 'Использование плана',
                'dashboard.sessionsTitle': 'Активные сессии',
                'dashboard.sessionsEmpty': 'Нет активных сессий',
                'dashboard.filesTitle': 'Мои файлы',
                'dashboard.viewFiles': 'Перейти к файлам',
                'dashboard.noBlocks': 'Нет активных блоков. Включите хотя бы один в настройках.',
                'dashboard.openSettings': 'Открыть настройки',
                'dashboard.goToContacts': 'К контактам',
                'dashboard.filesVisible': 'Видимые файлы',
                'dashboard.filesSampleNote': 'Счёт по первой странице (до 500+).',
                'dashboard.loading': 'Загрузка данных...',
                'dashboard.error.title': 'Ошибка',
                'dashboard.error.load': 'Не удалось загрузить данные об использовании',
                'dashboard.error.generic': 'Ошибка при загрузке панели управления',
                'dashboard.error.no_data': 'Не удалось загрузить данные',
                'dashboard.retry': 'Повторить',
                'dashboard.unlimited': 'Неограниченно',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                'dashboard.card.contacts': 'Контакты',
                'dashboard.card.chars': 'Символы',
                'dashboard.card.chars_month': 'Символы в этом месяце',
                'dashboard.card.storage': 'Хранилище',
                'dashboard.card.devices': 'Активные устройства',
                'dashboard.upgrade.title': 'Нужно больше ресурсов?',
                'dashboard.upgrade.message': 'Обновите план для большего числа контактов, символов, хранилища и активных устройств.',
                'dashboard.upgrade.button': 'Обновить план',
                'upgrade.title': 'Обновить план',
                'upgrade.close': 'Закрыть',
                'upgrade.cancel': 'Отмена',
                'upgrade.activate': 'Активировать план PRO',
                'upgrade.activating': 'Активация...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': 'Сравнение планов',
                'upgrade.free.label': 'Бесплатный план',
                'upgrade.free.limits.contacts': 'Максимум 2 контакта',
                'upgrade.free.limits.conversations': 'Максимум 2 разговора',
                'upgrade.free.limits.no_export': 'Нет экспорта данных',
                'upgrade.free.limits.no_advanced': 'Нет расширенных функций',
                'upgrade.pro.label': 'План Pro',
                'upgrade.pro.recommended': 'РЕКОМЕНДУЕТСЯ',
                'upgrade.pro.benefits.contacts': 'Неограниченные контакты',
                'upgrade.pro.benefits.contacts.desc': 'Добавляйте столько контактов, сколько вам нужно, без ограничений',
                'upgrade.pro.benefits.conversations': 'Неограниченные разговоры',
                'upgrade.pro.benefits.conversations.desc': 'Поддерживайте столько активных разговоров, сколько вам нужно',
                'upgrade.pro.benefits.export': 'Экспорт разговоров',
                'upgrade.pro.benefits.export.desc': 'Экспортируйте свои разговоры в нескольких форматах (PDF, TXT, JSON)',
                'upgrade.pro.benefits.notifications': 'Расширенные уведомления',
                'upgrade.pro.benefits.notifications.desc': 'Персонализированные уведомления и расширенная настройка',
                'upgrade.pro.benefits.translation': 'Неограниченный автоматический перевод',
                'upgrade.pro.benefits.translation.desc': 'Переводите сообщения без ограничений использования',
                'upgrade.pro.benefits.files': 'Неограниченная отправка файлов',
                'upgrade.pro.benefits.files.desc': 'Делитесь файлами любого размера без ограничений',
                'upgrade.pro.benefits.themes': 'Персонализированные темы',
                'upgrade.pro.benefits.themes.desc': 'Доступ ко всем темам и расширенная персонализация',
                'upgrade.pro.benefits.security': 'Расширенная безопасность',
                'upgrade.pro.benefits.security.desc': 'Дополнительная защита и улучшенные функции конфиденциальности',
                'upgrade.pro.benefits.analytics': 'Статистика и аналитика',
                'upgrade.pro.benefits.analytics.desc': 'Доступ к подробной статистике вашей активности',
                'upgrade.pro.benefits.priority': 'Приоритетная поддержка',
                'upgrade.pro.benefits.priority.desc': 'Приоритетное внимание и быстрый ответ на ваши запросы',
                'upgrade.enterprise.label': 'План Enterprise',
                'upgrade.enterprise.benefits.contacts': 'Неограниченные контакты',
                'upgrade.enterprise.benefits.support': 'Приоритетная поддержка 24/7',
                'upgrade.enterprise.benefits.custom': 'Индивидуальные решения',
                'upgrade.enterprise.benefits.advanced': 'Расширенные корпоративные функции',
                'upgrade.enterprise.benefits.integration': 'Индивидуальные интеграции',
                'upgrade.enterprise.benefits.dedicated': 'Выделенная поддержка',
                'upgrade.success.title': 'План PRO активирован',
                'upgrade.success.message': 'Ваш план был обновлен до PRO. Наслаждайтесь всеми неограниченными функциями.',
                'upgrade.error.title': 'Ошибка при активации PRO',
                'upgrade.error.message': 'Не удалось обновить план. Пожалуйста, попробуйте снова.',
                'upgrade.error.generic': 'Произошла непредвиденная ошибка. Пожалуйста, попробуйте снова.',
                'upgrade.benefits.contacts': 'Неограниченные контакты',
                'upgrade.benefits.contacts.desc': 'Добавляйте столько контактов, сколько вам нужно, без ограничений',
                'upgrade.benefits.conversations': 'Неограниченные разговоры',
                'upgrade.benefits.conversations.desc': 'Поддерживайте столько активных разговоров, сколько вам нужно',
                'upgrade.benefits.export': 'Экспорт разговоров',
                'upgrade.benefits.export.desc': 'Экспортируйте свои разговоры в нескольких форматах (PDF, TXT, JSON)',
                'upgrade.benefits.notifications': 'Расширенные уведомления',
                'upgrade.benefits.notifications.desc': 'Персонализированные уведомления и расширенная настройка',
                'upgrade.benefits.translation': 'Неограниченный автоматический перевод',
                'upgrade.benefits.translation.desc': 'Переводите сообщения без ограничений использования',
                'upgrade.benefits.files': 'Неограниченная отправка файлов',
                'upgrade.benefits.files.desc': 'Делитесь файлами любого размера без ограничений',
                'upgrade.benefits.themes': 'Персонализированные темы',
                'upgrade.benefits.themes.desc': 'Доступ ко всем темам и расширенная персонализация',
                'upgrade.benefits.security': 'Расширенная безопасность',
                'upgrade.benefits.security.desc': 'Дополнительная защита и улучшенные функции конфиденциальности',
                'upgrade.benefits.analytics': 'Статистика и аналитика',
                'upgrade.benefits.analytics.desc': 'Доступ к подробной статистике вашей активности',
                'upgrade.benefits.priority': 'Приоритетная поддержка',
                'upgrade.benefits.priority.desc': 'Приоритетное внимание и быстрый ответ на ваши запросы',
                'upgrade.limits.contacts': 'Максимум 2 контакта',
                'upgrade.limits.conversations': 'Максимум 2 разговора',
                'upgrade.limits.no_export': 'Нет экспорта данных',
                'upgrade.limits.no_advanced': 'Нет расширенных функций',
                // API Error Messages
                'api.error.image_processing_not_available': 'Обработка изображений недоступна на сервере',
                'api.error.image_functions_not_available': 'Функции обработки изображений недоступны',
                'api.error.method_not_allowed': 'Метод не разрешен',
                'api.error.user_not_identified': 'Пользователь не идентифицирован',
                'api.error.upload_file_too_large_php': 'Файл превышает максимальный размер, разрешенный PHP',
                'api.error.upload_file_too_large_form': 'Файл превышает максимальный размер, разрешенный формой',
                'api.error.upload_file_partial': 'Файл был загружен частично',
                'api.error.upload_no_file': 'Файл не был загружен',
                'api.error.upload_no_temp_dir': 'Временная директория отсутствует',
                'api.error.upload_cant_write': 'Ошибка записи файла на диск',
                'api.error.upload_extension_stopped': 'Расширение PHP остановило загрузку',
                'api.error.upload_generic': 'Ошибка загрузки файла',
                'api.error.file_type_not_allowed': 'Тип файла не разрешен. Разрешены только изображения (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': 'Файл слишком большой (макс 10MB)',
                'api.error.storage_limit_exceeded': 'Лимит хранилища превышен. Обновите свой план, чтобы загрузить больше файлов.',
                'api.error.user_not_found': 'Пользователь не найден или неактивен',
                'api.error.image_directory_access': 'Ошибка доступа к директории изображений',
                'api.error.file_extension_not_allowed': 'Расширение файла не разрешено',
                'api.error.temp_file_save': 'Ошибка сохранения временного файла',
                'api.error.image_processing': 'Ошибка обработки изображения',
                'api.error.database_update': 'Ошибка обновления базы данных',
                'api.error.internal_server_error': 'Внутренняя ошибка сервера',
                'api.error.internal_server_error_debug': 'Внутренняя ошибка сервера',
                'api.error.user_id_required': 'Требуется ID пользователя',
                'api.error.profile_not_found': 'Профиль не найден',
                'api.error.profile_load_failed': 'Ошибка загрузки профиля',
                'api.error.invalid_data': 'Неверные данные',
                'api.error.validation_errors': 'Ошибки валидации',
                'api.error.profile_update_failed': 'Не удалось обновить профиль',
                'api.error.profile_update_error': 'Ошибка обновления профиля',
                // API Success Messages
                'api.success.photo_updated': 'Фото обновлено',
                'api.success.profile_loaded': 'Профиль успешно загружен',
                'api.success.profile_updated': 'Профиль успешно обновлен',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'Достигнут лимит устройств',
                'errors.deviceLimit.solution': 'Чтобы продолжить, выйдите из других устройств или улучшите свой план.',
                // Error Messages - Network
                'errors.network.title': 'Ошибка подключения',
                'errors.network.message': 'Не удалось подключиться к серверу. Проверьте подключение к Интернету.',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'Ошибка сервера',
                'errors.server.invalidResponse.message': 'Сервер вернул недопустимый ответ. Попробуйте снова.',
                // Error Messages - Generic
                'errors.generic.title': 'Ошибка',
                'errors.generic.message': 'Произошла ошибка. Попробуйте снова.',
                'errors.generic.403.title': 'Ошибка доступа',
                'errors.generic.403.message': 'У вас нет разрешения на выполнение этого действия.',
                'errors.saas_max_users': 'Достигнут лимит пользователей плана ({current}/{limit}).',
                'errors.tenant_frozen': 'Тенант временно заблокирован.',
                'errors.auth_invalid_credentials': 'Неверное имя пользователя или пароль.',
                'errors.accountInactive.title': 'Аккаунт неактивен. Введите email для реактивации.',
                'errors.accountInactive.activate': 'Активировать сейчас',
                'errors.accountInactive.accept': 'Принять',
                'errors.accountInactive.success': 'Аккаунт реактивирован. Можете войти.',
                'errors.accountInactive.fail': 'Не удалось реактивировать аккаунт. Попробуйте снова.',
                'errors.accountInactive.completeSuccess': 'Аккаунт активирован с вашим email. Можете войти.',
                'errors.accountInactive.completeFail': 'Не удалось завершить активацию. Проверьте email и попробуйте снова.',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'Достигнут лимит плана',
                'plan.errors.deviceLimit.message': 'Ваш текущий план имеет ограничение на количество устройств, которые могут быть подключены одновременно.',
                'plan.errors.deviceLimit.solution': 'Чтобы продолжить, выйдите из других устройств или улучшите свой план до PRO.',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': 'Достигнут лимит контактов',
                'plan.errors.contactsLimit.message': 'Ваш текущий план имеет ограничение на количество контактов, которые вы можете иметь.',
                'plan.errors.contactsLimit.solution': 'Чтобы добавить больше контактов, улучшите свой план до PRO.',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': 'Достигнут лимит приглашений',
                'plan.errors.invitationsLimit.message': 'Ваш текущий план имеет ограничение на количество приглашений, которые вы можете отправить в день.',
                'plan.errors.invitationsLimit.solution': 'Чтобы отправить больше приглашений, улучшите свой план до PRO.',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'Достигнут лимит сообщений',
                'plan.errors.messagesLimit.message': 'Ваш текущий план имеет ограничение на количество сообщений, которые вы можете отправить в день.',
                'plan.errors.messagesLimit.solution': 'Чтобы отправить больше сообщений, улучшите свой план до PRO.',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'Достигнут лимит хранилища',
                'plan.errors.storageLimit.message': 'Ваш текущий план имеет ограничение на объем доступного хранилища.',
                'plan.errors.storageLimit.solution': 'Чтобы получить больше хранилища, улучшите свой план до PRO.',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'Требуется обновление плана',
                'plan.errors.upgradeRequired.message': 'Эта функция требует план выше вашего текущего.',
                'plan.errors.upgradeRequired.solution': 'Улучшите свой план до PRO, чтобы получить доступ к этой функции.',
                "appearance.theme.system": "Система",
                "appearance.theme.corporate": "Корпоративный",
                "theme.system": "Система",
                "theme.corporate": "Корпоративный",
                "founder.title": "ФОНД (Учредитель)",
                'founder.subtitle': 'Вы поддерживаете проект с самого начала по пожизненной цене.',
                'founder.whatIs': 'Первые 150 пользователей получают план FOUNDATION по сниженной пожизненной цене.',
                'founder.howItWorks': 'Ваш уровень Founder зависит от вашей позиции (1–150).',
                'founder.benefitsTitle': 'Преимущества',
                'founder.benefitPrice': '$15 / мес. (тариф Founder)',
                'founder.benefitFeatures': 'Включает все функции плана PRO.',
                'founder.limit': 'Существует только 150 мест Founder.',
                'founder.cancelRule': 'При отмене вы теряете статус Founder, пока подписка не активна.',
                'founder.rejoinRule': 'Если место снова освободится, вы можете реактивировать и снова стать Founder автоматически.',
                'founder.tiers.title': 'Уровни Founder',
                "founder.tiers.legendary.name": "ЛЕГЕНДАРНЫЙ Основатель",
                'founder.tiers.legendary.range': 'Позиция 1–25',
                'founder.tiers.legendary.desc': 'Первые поддержавшие проект. Высший исторический приоритет.',
                "founder.tiers.early.name": "РАННИЙ основатель",
                'founder.tiers.early.range': 'Позиция 26–75',
                'founder.tiers.early.desc': 'Ранняя поддержка с особым признанием.',
                "founder.tiers.founder.name": "основатель",
                'founder.tiers.founder.range': 'Позиция 76–150',
                'founder.tiers.founder.desc': 'Место Founder в рамках 150.',
                'founder.whatIsLink': 'Что такое Founder?',
                'founder.viewTiers': 'Посмотреть уровни Founder',
                'founder.modalClose': 'Закрыть',
                'founder.activeCountLabel': 'Активные Founders',
                'founder.urgency.lastSlots': 'Последние места Founder',
                "founder.positionLabel": "Основатель № {position} / {limit}",
                'founder.leaderboard.title': 'Топ Founders',
                "login.email.placeholder": "Ingresa tu email para confirmar tu cuenta",
                "login.email.help": "Ссылка для подтверждения будет отправлена ​​на вашу электронную почту",
                "auth.user_not_found": "Пользователь не найден.",
                "auth.user_inactive": "Ваша учетная запись деактивирована. Свяжитесь с администратором.",
                "auth.tenant_mismatch": "Ваша учетная запись не принадлежит этой среде. Свяжитесь с администратором.",
                "auth.captcha_required": "Вам необходимо пройти проверку безопасности (CAPTCHA).",
                "mail.send_failed": "Не удалось отправить письмо для восстановления. Проверьте настройки SMTP или повторите попытку позже.",
                "auth.resend_activation": "Повторно отправить письмо с активацией",
                "register.creatingAccount": "Создание учетной записи…",
                "common.edit": "Редактировать",
                "common.on": "Активировано",
                "common.off": "Неполноценный",
                "common.refresh": "Обновлять",
                "system.processing": "Обработка...",
                "captcha.incorrect": "Ответ по капче неправильный.",
                "captcha.placeholder": "Напишите ответ",
                "captcha.questionFormat": "Что такое {a} + {b}?",
                'menu.admin': 'Администрирование',
                "navbar.open_guide": "Гид",
                "invitation.quick_button": "Пригласить контакт",
                "onboarding.title": "Добро пожаловать в АрЧат®",
                "onboarding.subtitle": "Общайтесь с кем угодно на любом языке.",
                "onboarding.step1.label": "Шаг 1",
                "onboarding.step1.text": "Пригласите свой первый контакт",
                "onboarding.step2.label": "Шаг 2",
                "onboarding.step2.text": "Отправьте свое первое сообщение",
                "onboarding.actions.invite": "Пригласить контакт",
                "onboarding.actions.explore": "Откройте для себя АрЧат®",
                'suggestions.sendSuccess': 'Ваше предложение успешно отправлено.',
                'suggestions.sendError': 'Не удалось отправить предложение. Попробуйте снова.',
                'suggestions.sent': 'Предложение успешно отправлено.',
                'errors.suggestionSend': 'Не удалось отправить предложение. Попробуйте снова.',
                'app.install': 'Установить ArChat',
                'menu.open': 'Меню',
                "contacts.controls.hide_non_favorites": "Скрыть неизбранные контакты",
                "contacts.controls.show_all": "Показать все контакты",
                "common.navigation": "Навигация",
                "common.favorite": "Любимый",
                "common.block": "Блокировать",
                "common.user": "Пользователь",
                "message.new": "новое сообщение",
                "message.edit": "Редактировать сообщение",
                "message.edit.save": "Сохранить редактирование",
                "message.edit.cancel": "Отменить редактирование",
                'message.translating': 'Перевод...',
                'message.translation_failed': 'Не удалось перевести',
                'message.not_translated': 'Оригинальный текст',
                'message.retry_send': 'Повторить',
                'message.retrying': 'Повторная попытка...',
                "message.delete": "Удалить сообщение",
                'message.deleted_placeholder': 'Сообщение удалено',
                "message.edited": "Отредактировано",
                "message.edited_at": "Отредактировано",
                'message.delete_for_me.tooltip': 'Удалить для меня',
                'message.delete_for_me.aria': 'Удалить это сообщение только для меня',
                'message.delete_for_me.confirm_title': 'Удалить сообщение',
                'message.delete_for_me.confirm_message': 'Это сообщение будет удалено только из вашего просмотра.',
                'message.delete_for_everyone.tooltip': 'Удалить для всех',
                'message.delete_for_everyone.aria': 'Удалить это сообщение для всех участников',
                'message.delete_for_everyone.confirm_title': 'Удалить сообщение для всех',
                'message.delete_for_everyone.confirm_message': 'Это сообщение будет удалено у вас и у другого участника.',
                'message.delete_for_everyone.window_expired': 'Окно удаления истекло',
                "message.translation.show": "Посмотреть оригинал и перевод",
                "message.translation.hide": "Скрыть перевод",
                "emoji.search": "Поиск смайликов",
                "emoji.close": "Закрыть селектор",
                "captcha.refresh": "Восстановить капчу",
                'presence.unavailable': 'Status nedostupny',
                'presence.maintenance': 'Server na tekhnicheskom obsluzhivanii',
                "home.access_nav": "Доступ к приложению",
                "common.requiredFields": "Заполните все обязательные поля.",
                "bio.view": "См. биографию",
                "profile.nick.readonly": "Имя пользователя не может быть изменено",
                "profile.nick.readonly.help": "Имя пользователя уникально и не может быть изменено",
                "profile.email.readonly": "Электронную почту нельзя изменить",
                "profile.email.readonly.help": "Электронная почта уникальна и не может быть изменена.",
                "profile.invitations.title": "Приглашения",
                "profile.invitations.validated": "Подтвержденные приглашения",
                "profile.invitations.nextBadge": "Следующее достижение",
                "profile.invitations.progress": "Прогресс",
                "profile.invitations.achievement": "Достижение",
                "profile.invitations.topInviterAchieved": "Достигнуто максимальное количество приглашенных",
                "profile.invitations.badges.networkBuilder": "Сетевой строитель",
                "profile.invitations.badges.topInviter": "Максимальное количество приглашенных",
                "profile.invitations.achievement.networkBuilderMessage": "Вы пригласили 20 пользователей в ArChat.",
                "profile.invitations.achievement.topInviterMessage": "Вы пригласили 50 пользователей в ArChat.",
                "profile.manage_plan": "Управление планом",
                "plan.current_plan": "Текущий план",
                "plan.current": "Actual",
                'plan.footer_prefix': 'План:',
                "plan.upgrade_to_pro": "Обновите до PRO",
                "plan.upgrade_to_foundation": "Обновление до FOUNDATION",
                "plan.payment_coming": "Оплата с помощью Paddle будет доступна в ближайшее время. Вы можете изменить планы отсюда.",
                "plan.payment_coming_title": "Скоро",
                "plan.foundation_full": "Квота ФОНДА полная (150 учредителей). Вы можете выбрать ПРО.",
                "plan.sold_out": "Измученный",
                "plan.founder_spots_remaining": "Доступно только {count} мест",
                "plan.founders_occupied": "занятые основатели",
                "plan.upgrade_not_allowed": "Только пользователи с БЕСПЛАТНЫМ планом могут запросить обновление.",
                "plan.free_contacts": "Hasta 2 contactos",
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "Контакты",
                "billing.usage.chars_month": "Персонажей в месяц",
                "billing.usage.storage": "Использованное хранилище",
                "billing.usage.devices": "Подключенные устройства",
                "billing.loading": "Зарядка...",
                'billing.subscription.section_title': 'Подписка и оплата',
                'billing.subscription.provider_note': 'Провайдер',
                'billing.subscription.paddle_active': 'Paddle (активный план в приложении)',
                'billing.subscription.mp_action_ok': 'Запрос записан. Если оплата не открылась, проверьте соединение или повторите попытку.',
                'billing.paddle.manage_subscription_button': 'Управлять подпиской',
                'billing.paddle.portal_confirm_title': 'Портал оплаты',
                'billing.paddle.portal_confirm': 'Откроется защищённый портал Paddle для обновления способа оплаты, счетов или отмены подписки. Продолжить?',
                'billing.paddle.portal_opened_hint': 'Портал Paddle открыт в новой вкладке. Обновите профиль, если план не изменился.',
                'billing.paddle.portal_error': 'Не удалось открыть портал Paddle. Повторите позже или обратитесь в поддержку.',
                'billing.paddle.no_link_error': 'На аккаунте ещё нет привязки подписки Paddle. Если вы только что оплатили, дождитесь webhook или обратитесь в поддержку.',
                'billing.paddle.api_not_configured': 'На сервере не настроен Paddle API (PADDLE_API_KEY). Администратор должен задать переменные.',
                "billing.descriptions.contacts": "Общее количество контактов, сохраненных в вашей учетной записи",
                "billing.descriptions.storage": "Хранилище, используемое для файлов и мультимедиа",
                "billing.descriptions.chars_month": "Персонажи, переведенные в этом месяце",
                "billing.descriptions.devices": "Активные подключенные устройства",
                'billing.paddle.return_title': 'Платёж получен',
                'billing.paddle.return_body': 'Если вы завершили оплату, план обновится вскоре после подтверждения Paddle. Можно вернуться на главную.',
                'billing.paddle.verifying': 'Проверка плана…',
                'billing.paddle.not_logged_in': 'Войдите, чтобы увидеть актуальный статус плана.',
                'billing.paddle.plan_updated': 'План обновлён: {plan}',
                'billing.paddle.plan_current': 'Ваш текущий план: {plan}',
                'billing.paddle.plan_current_founder': 'Вы теперь Founder — {plan}',
                'billing.paddle.still_free_hint': 'Если через некоторое время всё ещё FREE, webhook может задержаться. Проверьте логи бэкенда или обновите страницу.',
                'billing.paddle.pro_extra_hint': 'Можно вернуться на главную, чтобы пользоваться планом.',
                "profile.photo.select": "Выбрать фото",
                "profile.photo.select.gallery": "Выбрать из галереи",
                "avatar.errors.too_large": "Изображение слишком большое. Максимальный размер: 2 МБ.",
                "avatar.preview.title": "Предварительный просмотр аватара",
                "profile.avatar.error_title": "Не удалось обновить аватар",
                "profile.avatar.error.title": "Не удалось обновить аватар",
                "profile.avatar.error.size": "Изображение превышает допустимый размер. Максимум — 2 МБ.",
                "profile.avatar.tooLarge.title": "Изображение слишком большое",
                "profile.avatar.tooLarge.message": "Фотография превышает допустимый размер. Максимум — 2 МБ.",
                "profile.avatar.uploadError.title": "Не удалось обновить аватар",
                "profile.avatar.uploadError.message": "Возникла проблема с загрузкой изображения. Попробуйте еще раз.",
                "profile.saveSuccess.title": "Обновленный профиль",
                "profile.saveSuccess.message": "Ваши изменения успешно сохранены.",
                "profile.avatar.file_too_large": "Размер изображения превышает максимально допустимый размер (2 МБ).",
                "profile.avatar.file_too_large_hint": "Выберите более светлое изображение или уменьшите его размер и повторите попытку.",
                "profile.photo.take.front": "передняя камера",
                "profile.photo.take.back": "задняя камера",
                "profile.photo.take.webcam": "Веб-камера",
                "profile.photo.camera.front": "передняя камера",
                "profile.photo.camera.back": "задняя камера",
                "profile.photo.camera.web": "Веб-камера",
                "profile.photo.close": "Закрывать",
                "profile.photo.capture": "Захватывать",
                "block.toggle_error": "Не удалось заблокировать или разблокировать.",
                "contact.favorite.add": "Добавить в избранное",
                "contact.favorite.remove": "Удалить из избранного",
                "contact.block.block": "Блокировать",
                'contact.block.unblock': 'Разблокировать',
                "conversation.notFound": "Разговор не найден",
                "help.howWorks.title": "👥 Как работает ArChat® (реальный поток)",
                "help.howWorks.step1.title": "1️⃣ Регистрация",
                "help.howWorks.step1.point1": "Войдите под своим ником и паролем.",
                "help.howWorks.step1.point2": "Если у вас нет учетной записи, она создается автоматически.",
                "help.howWorks.step1.point3": "Вы принимаете Условия использования на своем языке.",
                "help.howWorks.step1.point4": "Вы подтверждаете свою учетную запись по электронной почте.",
                "help.howWorks.step2.title": "2️⃣ Частные приглашения",
                "help.howWorks.step2.point1": "Пригласите контакты по электронной почте из вашего профиля.",
                "help.howWorks.step2.point2": "Прежде чем начать, определите язык и режим разговора.",
                "help.howWorks.step2.point3": "Контакт получит частное приглашение.",
                "help.howWorks.step2.point4": "Вы можете увидеть, если он: Ожидает, Зарегистрирован, Готов к общению.",
                "help.howWorks.step2.point5": "Контакты не ищут, их приглашают.",
                "help.howWorks.step2.point6": "Контакты не ищут, их приглашают.",
                "help.howWorks.step3.title": "3️⃣ Контакты и разговоры",
                "help.howWorks.step3.point1": "Ваши контакты появляются автоматически, когда:",
                "help.howWorks.step3.point2": "принять приглашение",
                "help.howWorks.step3.point3": "или есть разговор",
                "help.howWorks.step3.point4": "Может:",
                "help.howWorks.step3.point5": "отметьте их как избранные ⭐",
                "help.howWorks.step3.point6": "назначьте им собственные псевдонимы",
                "help.howWorks.step3.point7": "добавить личные заметки",
                "help.howWorks.step3.point8": "блокировать или управлять ими",
                "help.howWorks.step3.point9": "Не существует публичной повестки дня или видимых пользователей без согласия.",
                "help.howWorks.step4.title": "4️⃣ Переписка с переводом",
                "help.howWorks.step4.point1": "Всегда пишите на своем языке.",
                "help.howWorks.step4.point2": "Система автоматически переводит сообщение.",
                "help.howWorks.step4.point3": "Получатель получает его на своем языке.",
                "help.howWorks.step4.point4": "Вы можете увидеть примененный перевод.",
                "help.howWorks.step4.point5": "Если перевод не удался, он автоматически повторяется.",
                "help.howWorks.step4.point6": "ArChat® отдает приоритет ясности и смыслу, а не только скорости.",
                "help.privacy.title": "🔒 Конфиденциальность и контроль",
                "help.privacy.point1": "По умолчанию ваш профиль является закрытым.",
                "help.privacy.point2": "Только те, кого вы приглашаете, могут видеть вас или писать вам.",
                "help.privacy.point3": "Публичная видимость не является обязательной и отключена по умолчанию.",
                "help.privacy.point4": "Активная безопасность с:",
                "help.privacy.point5": "КАПЧА",
                "help.privacy.point6": "ограничение скорости",
                "help.privacy.point7": "отпечаток пальца",
                "help.privacy.point8": "проверка электронной почты",
                "help.privacy.point9": "Ваши разговоры не являются общедоступными и не индексируются.",
                "help.files.title": "📎 Файлы и экспорт",
                "help.files.point1": "Прикрепляйте изображения, видео и PDF-документы.",
                "help.files.point2": "Снимайте фотографии с помощью передней, задней или веб-камеры.",
                "help.files.point3": "Изображения автоматически сжимаются.",
                "help.files.point4": "Предварительный просмотр перед отправкой.",
                "help.files.point5": "Индикатор выполнения во время загрузки.",
                "help.files.point6": "Экспортируйте целые разговоры в:",
                "help.files.point7": "PDF",
                "help.files.point8": "HTML",
                "help.files.point9": "Включает сообщения, изображения и файлы.",
                "help.files.point10": "Ваши данные принадлежат вам.",
                "help.experience.title": "🎨 Пользовательский опыт",
                "help.experience.point1": "Статусы присутствия и пользовательские статусы с эмодзи.",
                "help.experience.point2": "Интегрированные смайлы OpenMoji.",
                "help.experience.point3": "Чтение и запись индикаторов.",
                "help.experience.point4": "Оптимизированный мобильный вид, равный настольному компьютеру.",
                "help.experience.point5": "Устанавливаемое PWA-приложение.",
                "help.experience.point6": "Две темы: Аргентина (голубой/белый/золотой) и Оскуро (темно-фиолетовый).",
                "help.experience.point7": "Редактирование профиля без прохладительных напитков.",
                "help.experience.point8": "Выбор страны с автоматическим часовым поясом.",
                "help.experience.point9": "Быстрый доступ с избранным, поиском и фильтрами.",
                "help.languages.title": "🌍 Языки",
                "help.languages.point1": "Поддержка {count} языков.",
                "help.languages.point2": "Визуальный селектор с флагами.",
                "help.languages.point3": "Интерфейс, Условия и электронные письма адаптированы к выбранному языку.",
                "help.languages.point4": "Двусторонний автоматический перевод между пользователями.",
                "help.tipsNew.title": "💡 Советы по использованию ArChat®",
                "help.tipsNew.point1": "Приглашайте только тех, с кем действительно хотите общаться.",
                "help.tipsNew.point2": "Используйте псевдонимы и личные заметки для организации контактов.",
                "help.tipsNew.point3": "Отметьте избранное для быстрого доступа.",
                "help.tipsNew.point4": "Проверьте перевод перед отправкой важных сообщений.",
                "help.tipsNew.point5": "Экспортируйте соответствующие разговоры для резервного копирования или работы.",
                "help.tipsNew.point6": "Используйте ArChat®, когда ясность письма имеет решающее значение.",
                "help.whySubscribe.title": "🚀 Зачем подписываться на АрЧат®",
                "help.whySubscribe.point1": "ArChat® не предназначен для общения с кем угодно,",
                "help.whySubscribe.point2": "но лучше общаться с теми, кто имеет значение.",
                "help.whySubscribe.point3": "Если вам нужно:",
                "help.whySubscribe.point4": "ясность между языками",
                "help.whySubscribe.point5": "настоящая конфиденциальность",
                "help.whySubscribe.point6": "контактное управление",
                "help.whySubscribe.point7": "экспорт разговора",
                "help.whySubscribe.point8": "профессиональный и бесшумный опыт",
                "help.whySubscribe.point9": "ArChat® создан для этого.",
                "help.tips.themes": "✅ Измените тему в «Настройки» > «Внешний вид»: «Аргентина» (светло-синий) или «Темный» (темно-фиолетовый).",
                "help.message_time_context.title": "Временной контекст сообщений",
                "help.message_time_context.description": "Каждое сообщение может сохранять местное время отправителя, часовой пояс и страну на момент отправки. Таким образом, вы сможете увидеть, куда и в какое время отправил другой пользователь.",
                "help.message_time_context.point1": "В тарифе FREE отображается только время вашего часового пояса (приемника).",
                "help.message_time_context.point2": "В плане PRO также отображается местное время, страна и часовой пояс эмитента.",
                "help.message_time_context.point3": "Контекст сохраняется исторически в каждом сообщении.",
                "help.message_time_context.point4": "Расширенные функции аудита доступны на более высоких планах.",
                'presence.custom.title': 'Polzovatelskiy status',
                'presence.custom.status': 'Polzovatelskiy status',
                'presence.custom.placeholder': 'Naprimer: Pyu kofe ☕',
                'presence.custom.emoji': 'Emoji (neobyazatelno)',
                'presence.custom.emojiHelp': 'Vyberite emoji ili vvedite ego',
                'presence.custom.temporary': 'Vremennyy status (istekaet avtomaticheski)',
                'presence.custom.expiration': 'Data istecheniya',
                'presence.custom.expirationHelp': 'Status vernetsya na "Onlayn" posle istecheniya',
                'presence.custom.suggestions': 'Podskazki',
                'presence.custom.preview': 'Predprosmotr',
                'presence.custom.save': 'Sohranit status',
                'presence.custom.required': 'Polzovatelskiy status obyazatelen',
                'presence.custom.maxLength': 'Maksimum 64 simvola',
                'presence.custom.expirationRequired': 'Nuzhno vybrat datu istecheniya',
                'presence.custom.expirationFuture': 'Data istecheniya dolzhna byt v budushchem',
                'presence.custom.selectEmoji': 'Vybrat emoji',
                "invitation.success.title": "Приглашение отправлено",
                "invitation.success.message": "Приглашение успешно отправлено.\\n\\nКонтакт получит электронное письмо со ссылкой для принятия приглашения. После принятия вы можете начать с ним общение.",
                "invitation.top.title": "Лучшие строители сетей",
                "invitation.top.invitesSuffix": "приглашения",
                "invitation.ranking.position": "Позиция",
                "invitation.ranking.user": "Пользователь",
                "invitation.ranking.validatedInvites": "Подтвержденные приглашения",
                "invitation.ranking.empty": "Нет подтвержденных приглашений для отображения.",
                "invitation.ranking.loading": "Загрузка рейтинга...",
                "invitation.ranking.loadError": "Не удалось загрузить рейтинг.",
                "invitations.waitBeforeResend": "Вы пока не можете повторно отправить приглашение. Вы должны подождать 10 минут между каждой отправкой, чтобы не рассылать спам гостевому пользователю.",
                "invitations.captchaQuestion": "Сколько стоит %1 + %2?",
                "invitations.resendSuccess": "Приглашение успешно отправлено.",
                "invitations.dailyLimit": "Сегодня вы достигли максимально разрешенного количества повторных отправок.",
                "invitations.invalidEmail": "Почтовый сервер сообщил, что этот адрес недействителен.",
                "achievement.unlocked": "Достижение разблокировано",
                "achievement.continue": "Продолжать",
                'dashboard.not_available': 'Недоступно',
                "plan.errors.chatsLimit.title": "Достигнут лимит разговоров",
                "plan.errors.chatsLimit.message": "Ваш текущий план имеет ограничение на количество разговоров, которые вы можете вести.",
                "plan.errors.chatsLimit.solution": "Чтобы создавать больше разговоров, обновите свой план до PRO.",
                "errors.generic": "Произошла непредвиденная ошибка. Попробуйте еще раз.",
                "errors.modal.title": "Ошибка",
                "errors.modal.copyDetails": "Копировать детали",
                "errors.modal.close": "Закрывать",
                "errors.modal.reportSupport": "Сообщите в службу поддержки",
                "errors.avatarTooLarge": "Размер изображения превышает разрешенный размер 2 МБ.",
                "errors.avatarTooLarge.title": "Изображение слишком большое",
                "errors.avatarTooLarge.message": "Размер изображения превышает разрешенный размер 2 МБ.",
                "errors.invalidImageType": "Выбранный файл не является допустимым изображением.",
                "errors.invalidImageType.title": "Неверный файл",
                "errors.invalidImageType.message": "Выбранный файл не является допустимым изображением.",
                "errors.uploadFailed": "Не удалось загрузить изображение. Попробуйте еще раз.",
                "errors.uploadFailed.title": "Ошибка загрузки",
                "errors.uploadFailed.message": "Не удалось загрузить изображение. Попробуйте еще раз.",
                "errors.conversationCreate": "Ошибка создания беседы. Пожалуйста, попробуйте еще раз.",
                "errors.conversationInvalidId": "Неверный идентификатор беседы.",
                "errors.conversationOpen": "Ошибка открытия чата. Пожалуйста, попробуйте еще раз.",
                "errors.favoriteUpdate": "Не удалось обновить избранное",
                "errors.blockUpdate": "Не удалось обновить блокировку",
                "errors.messageEdit": "Сообщение об ошибке редактирования.",
                "errors.foundation_sold_out": "Места основателя распроданы.",
                "errors.unexpected_error": "Произошла непредвиденная ошибка. Попробуйте еще раз.",
                "errors.userInactive.title": "Деактивированная учетная запись",
                "errors.tenantMismatch.title": "Ошибка арендатора",
                'auth.tagline': 'Сила быть понятым, независимо от языка',
                'auth.sign_in': 'Войти',
                'auth.create_account': 'Создать аккаунт',
                'ui.search_contact': 'Поиск контакта...',
                'ui.language': 'Язык',
                'profile.my_profile': 'Мой профиль',
                'profile.status': 'Статус',
                'profile.invite_email': 'Пригласить Контакт по Email',
                'profile.sent_invitations': 'Отправленные Приглашения',
                'profile.users': 'Пользователи',
                'profile.settings': 'Настройки',
                'profile.appearance': 'Внешний вид',
                'profile.logout': 'Выйти',
                'contacts.mode': 'Режим',
                'contacts.sent': 'Отправлено',
                'contacts.actions': 'Действия',
                'contacts.pending': 'Ожидает',
                'contacts.available': 'Доступен',
                'contacts.invited_registered': 'Приглашён - Зарегистрирован',
                "table.email": "Электронная почта",
                'table.language': 'Язык',
                'table.mode': 'Режим',
                'table.status': 'Статус',
                'table.sent': 'Отправлено',
                'table.actions': 'Действия',
  'promotions.invite.message': 'Приглашаю вас в АрЧат — говорите на любом языке. Мы оба получаем выгоду.',
  'promotions.progress.pending': 'У вас есть ожидающие приглашения на разблокировку наград.',
  'promotions.progress.in_progress': 'Ваши приглашения в обработке: награды активируются после реального разговора.',
  'promotions.progress.remaining': 'Вам нужно еще {count} разговора, чтобы получить награду.',
  'promotions.progress.sent_count': 'Отправил',
  'promotions.progress.pending_count': 'В ожидании',
  'promotions.progress.in_progress_count': 'В ходе выполнения',
  'promotions.progress.completed_count': 'Завершенный',
  'promotions.banner.empty': 'Начните прямо сейчас: приглашайте контакты и открывайте преимущества.',
  'promotions.banner.pending': 'У вас есть ожидающие приглашения: завершите настоящий разговор и получите награды.',
  'promotions.banner.reward': 'Вы уже разблокировали награды! Продолжайте приглашать, чтобы увеличить свои доходы.',
  'promotions.cta.copy': 'Скопировать сообщение и ссылку',
  'promotions.cta.copied': 'Сообщение скопировано',
  'promotions.cta.copy_error': 'Не удалось скопировать сообщение',

  'promotions.title': 'Акции и награды',
  'promotions.subtitle': 'Приглашайте контакты и открывайте преимущества при реальном использовании.',
  'promotions.how_it_works': 'Как это работает',
  'promotions.step1': 'Пригласите контакт из вашего профиля.',
  'promotions.step2': 'Когда они принимают приглашение и общаются с реальным взаимодействием, оно проверяется автоматически.',
  'promotions.step3': 'Награда зачисляется, и ваш прогресс обновляется.',
  'promotions.rewards.title': 'Награды',
  'promotions.reward.invite': 'Вознаграждение за каждого подтвержденного реферала.',
  'promotions.reward.milestone': 'Бонусы за успехи в развитии.',
  'promotions.reward.ranking': 'Видимость в рейтинге лучших сетевых строителей.',
  'promotions.progress.title': 'Ваш прогресс',
  'promotions.progress.sent': 'Отправил',
  'promotions.cta.invite': 'Пригласить контакт',
  'promotions.banner': 'Активируйте акции: приглашайте и получайте вознаграждения за реальное использование.',
  'promotions.modal.title': 'Программа акций',
  'promotions.modal.body': 'Заработайте +10 000 символов за каждое подтвержденное приглашение.\\\\nПригласите сегодня и разблокируйте награды.',
  'promotions.modal.cta': 'Посмотреть акции',
                "app.install_ios_hint": "Чтобы установить: «Поделиться» > «Добавить на главный экран».",
                'menu.promotions': 'Акции',
                "suggestions.new": "Новое предложение",
                "suggestions.empty": "У вас еще нет отправленных предложений.",
                "suggestions.admin_note": "Примечание команды",
                "suggestions.status.pending": "Серьга",
                "suggestions.status.reviewed": "Пересмотренный",
                "suggestions.status.planned": "Планируется",
                "suggestions.status.implemented": "Реализовано",
                "suggestions.status.rejected": "Отклоненный",
                "referral.promo": "Пригласите и выиграйте 10 000 персонажей",
                "referral.stats.sent": "Отправил",
                "referral.stats.accepted": "Принял",
                "referral.stats.rewards": "Награды",
                "referral.reward.pending": "Серьга",
                "referral.reward.granted": "Заполненный",
                "referral.reward.invalid": "Неверный",
                "referral.reward.in_progress": "В использовании",
                "referral.limit.reached": "Достигнут лимит вознаграждения",
                "referral.waiting.usage": "+10 000 символов каждый, если вы и ваш гость отправляете хотя бы одно настоящее текстовое сообщение в одном чате (проверено сервером).",
                "common.avatar": "Аватар",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": "Сообщений пока нет",
                "messages.loading": "Загрузка сообщений...",
                "messages.connecting_server": "Подключение к серверу сообщений...",
                "messages.pending_send_count": "Сообщений: {count}, ожидающих доставки",
                "presence.custom.suggestion.coffee": "Есть друзья ☕",
                "presence.custom.suggestion.soccer": "На площадке ⚽",
                "presence.custom.suggestion.working": "Работаю как сумасшедший 💪",
                "presence.custom.suggestion.lunch": "Обедаем 🍽️",
                "presence.custom.suggestion.family": "Семейный обед 👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "Учусь 📚",
                "presence.custom.suggestion.travel": "В поездке ✈️",
                "presence.custom.suggestion.meeting": "При встрече 💼",
                "presence.custom.suggestion.resting": "Отдыхаю 😴",
                "presence.custom.suggestion.gaming": "Играю в видеоигры 🎮",
                "presence.custom.suggestion.reading": "Читаю 📖",
                "presence.custom.suggestion.offlineSoon": "Я скоро вернусь ⏳",
                "invitation.safe.phase_notice": "Активная безопасная фаза: преимущества ожидают коммерческой активации (реального влияния на лимиты нет).",
                "invitation.safe.generate_code": "Создать ссылку/код",
                "invitation.safe.refresh_top3": "Обновить топ-3",
                "invitation.safe.top_loading": "Загрузка лучших приглашенных...",
                "invitation.safe.top_empty": "Избранных приглашенных пока нет.",
                "invitation.safe.hide_full_ranking": "Скрыть полный рейтинг",
                "invitation.safe.view_full_ranking": "Посмотреть полный рейтинг",
                "invitation.safe.hide_metrics_dashboard": "Скрыть панель показателей",
                "invitation.safe.view_metrics_dashboard": "Просмотр панели показателей",
                "invitation.safe.prepared_link": "Ссылка подготовлена",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "Зарегистрироваться в ожидании приглашения",
                "invitation.safe.status_summary": "Сводка статуса",
                "invitation.safe.summary.pending": "Серьги",
                "invitation.safe.summary.registered": "Зарегистрирован",
                "invitation.safe.summary.active": "Активный",
                "invitation.safe.summary.validated": "проверено",
                "invitation.safe.summary.rejected": "Отклоненный",
                "invitation.safe.sent_invitations": "Приглашения выданы",
                "invitation.safe.table.id": "ИДЕНТИФИКАТОР",
                "invitation.safe.table.invited_email": "Гостевая электронная почта",
                "invitation.safe.table.code": "Код",
                "invitation.safe.table.status": "Состояние",
                "invitation.safe.table.created": "Созданный",
                "invitation.safe.empty_sent": "Приглашения пока не выданы.",
                "invitation.safe.simulated_rewards": "Получено симулированное вознаграждение",
                "invitation.safe.empty_rewards": "На данный момент никаких симулированных наград.",
                "invitation.safe.error.load_status": "Не удалось загрузить статус приглашения.",
                "invitation.safe.error.generate_code": "Код не удалось сгенерировать.",
                "invitation.safe.error.invalid_email": "Введите действительный адрес электронной почты, чтобы зарегистрировать приглашение.",
                "invitation.safe.error.register_pending": "Ожидаемое приглашение не удалось зарегистрировать.",
                "invitation.safe.success.code_generated": "Код успешно сгенерирован.",
                "invitation.safe.success.pending_registered": "Ожидающее приглашение зарегистрировано в безопасном режиме.",
                "invitation.status.deleted": "Устранено",
                "invitation.deleted.tooltip": "Это приглашение было удалено",
                "invitation.status.rejected": "Отклоненный",
                "invitation.status.bounced": "отскочил",
                "invitation.status.unknown": "Неизвестный статус",
                "dashboard.admin.title": "Показатели роста",
                "dashboard.admin.newUsersToday": "Новые пользователи сегодня",
                "dashboard.admin.messagesSentToday": "Сообщения отправлены сегодня",
                "dashboard.admin.translationsUsed": "Использованные переводы",
                "dashboard.admin.invitesCreated": "Приглашения созданы",
                "dashboard.admin.invitesValidated": "Подтвержденные приглашения",
                "dashboard.admin.inviteConversion": "Преобразование приглашения",
                "dashboard.admin.kFactor": "К-фактор",
                "dashboard.admin.newUsers": "Новые пользователи",
                "dashboard.admin.messagesSent": "Отправленные сообщения",
                "dashboard.admin.noData": "Нет данных",
                "dashboard.admin.kFactor.viral": "Популярный",
                "dashboard.admin.kFactor.stable": "Стабильный",
                "dashboard.admin.kFactor.low": "Низкий",
                "dashboard.admin.emailMetrics": "Метрики электронной почты",
                "dashboard.admin.email.sent": "Отправил",
                "dashboard.admin.email.delivered": "Доставленный",
                "dashboard.admin.email.opened": "открыть",
                "dashboard.admin.email.clicked": "Клики",
                "dashboard.admin.email.bounced": "отскочил",
                "dashboard.admin.email.deliveryRate": "Скорость доставки",
                "dashboard.admin.email.openRate": "Открытая ставка",
                "dashboard.admin.email.bounceRate": "показатель отказов",
                "dashboard.admin.funnelMetrics": "Метрики воронки",
                "dashboard.admin.funnel.registered": "Зарегистрирован",
                "dashboard.admin.funnel.confirmed": "Подтвержденный",
                "dashboard.admin.funnel.loggedIn": "Первый вход",
                "dashboard.admin.funnel.firstMessage": "Первое сообщение",
                "dashboard.admin.funnel.abandoned": "Заброшенный",
                "dashboard.admin.funnel.conversionRate": "Коэффициент конверсии",
                "dashboard.admin.funnel.activationRate": "Скорость активации",
                "dashboard.admin.funnel.dropoffRate": "Уровень отсева",
                "dashboard.admin.loading": "Загрузка показателей...",
                "dashboard.admin.errorLoad": "Не удалось загрузить панель показателей.",
                "dashboard.admin.growthViral": "Вирусный рост",
                "dashboard.admin.growthStable": "Стабильный рост",
                "dashboard.admin.growthLow": "Низкий рост",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "Код",
                "errors.modal.message": "Сообщение",
                "errors.modal.path": "Маршрут",
                "errors.modal.time": "Час",
                "errors.modal.timestamp": "Временная метка",
                "errors.modal.copied": "Скопированная деталь",
                "errors.network": "Не удалось подключиться к серверу. Проверьте свое соединение.",
                "errors.unexpected": "Произошла непредвиденная ошибка. Попробуйте еще раз.",
                "errors.boundary.title": "РЕАКТИВНАЯ ОШИБКА ЗАПРЕЩЕНА",
                "errors.boundary.request_id": "X-Request-ID:",
                "errors.boundary.correlate": "Сопоставить с backend/logs/structured.log",
                "errors.boundary.message_label": "Сообщение:",
                "errors.boundary.stack_trace": "Трассировка стека",
                "errors.boundary.component_stack": "стек компонентов",
                "errors.boundary.empty": "(пустой)",
                "errors.boundary.reload_page": "Обновить страницу",
                "errors.ui_boundary.refresh": "Ошибка интерфейса ArChat — перезагрузка страницы",
                "bootstrap.error.title": "ArChat® — Ошибка загрузки",
                "common.reload": "Перезарядка",
                "admin.access_denied.message": "Сообщение",
                "admin.access_denied.title": "Заголовок",
                "admin.action.change_plan": "Изменить план",
                "admin.action.reactivate": "Повторно активировать",
                "admin.action.suspend": "Приостановить",
                "admin.action.view": "Вид",
                "admin.confirm.change_plan.message": "Сообщение",
                "admin.confirm.change_plan.title": "Заголовок",
                "admin.confirm.suspend.message": "Сообщение",
                "admin.confirm.suspend.title": "Заголовок",
                "admin.details.created": "Созданный",
                "admin.details.current_plan": "Текущий план",
                "admin.details.domain": "Домен",
                "admin.details.last_activity": "Последняя активность",
                "admin.details.name": "сладкий картофель",
                "admin.details.plan": "План",
                "admin.details.status": "Статус",
                "admin.details.subscription": "Подписка",
                "admin.details.tenant_id": "Идентификатор арендатора",
                "admin.details.tenant_info": "Информация об арендаторе",
                "admin.details.usage": "Использование",
                "admin.error.change_plan": "Изменить план",
                "admin.error.generic": "Общий",
                "admin.error.load_details": "Загрузить детали",
                "admin.error.load_tenants": "Загрузка арендаторов",
                "admin.error.reactivate": "Повторно активировать",
                "admin.error.suspend": "Приостановить",
                "admin.error.title": "Заголовок",
                "admin.filter.active": "Активировать",
                "admin.filter.all_plans": "Все планы",
                "admin.filter.all_status": "Все статусы",
                "admin.filter.suspended": "Приостановить",
                "admin.limit.devices": "Устройства",
                "admin.limit.invitations": "Приглашения",
                "admin.limit.messages": "сообщения",
                "admin.limit.storage": "Хранилище",
                "admin.limit.users": "Пользователи",
                "admin.loading": "Загрузка",
                "admin.no_tenants": "Неарендаторы",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "Активировать",
                "admin.status.suspended": "Приостановить",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "Последний платеж",
                "admin.subscription.status": "Статус",
                "admin.subtitle": "Субтитры",
                "admin.success.plan_changed": "План изменен",
                "admin.success.tenant_reactivated": "Арендатор возобновлен",
                "admin.success.tenant_suspended": "Арендатор приостановлен",
                "admin.success.title": "Заголовок",
                "admin.table.actions": "Действия",
                "admin.table.messages": "сообщения",
                "admin.table.name": "сладкий картофель",
                "admin.table.plan": "План",
                "admin.table.status": "Статус",
                "admin.table.storage": "Хранилище",
                "admin.table.tenant_id": "Идентификатор арендатора",
                "admin.table.users": "Пользователи",
                "admin.title": "Заголовок",
                "admin.usage.devices": "Устройства",
                "admin.usage.invitations": "Приглашения",
                "admin.usage.messages": "сообщения",
                "admin.usage.storage": "Хранилище",
                "admin.usage.users": "Пользователи",
                "auth.login": "Авторизоваться",
                "auth.register": "Зарегистрироваться",
                "auth.reset_password": "сбросить пароль",
                "billing.cancel.button": "кнопка",
                "billing.cancel.canceling": "Отмена",
                "billing.cancel.confirm": "Подтверждать",
                "billing.cancel.error": "Ошибка",
                "billing.cancel.success": "успех",
                "billing.character_billing.characters_used": "Используемые символы",
                "billing.character_billing.consumption_pct": "Процент потребления",
                "billing.character_billing.days_remaining": "Осталось дней",
                "billing.character_billing.deletion_date": "Дата удаления",
                "billing.character_billing.period_start": "Начало периода",
                "billing.character_billing.renewal_date": "Дата продления",
                "billing.character_billing.title": "Заголовок",
                "billing.current_plan": "Текущий план",
                "billing.founder_badge": "Значок основателя",
                "billing.no_plans": "Не планируй",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "Следующий платеж",
                "billing.subscription.plan": "План",
                'billing.subscription.price': 'Цена плана',
                "billing.subscription.started": "Началось",
                "billing.subscription.status": "Статус",
                "billing.subscription.mp_flow.subscribe_failed": "Не удалось запустить подписку. Попробуйте еще раз.",
                "billing.subscription.mp_flow.change_plan_failed": "План нельзя было изменить. Попробуйте еще раз.",
                "billing.subscription.mp_status.pending": "Серьга",
                "billing.subscription.mp_status.authorized": "Авторизованный",
                "billing.subscription.mp_status.active": "Активный",
                "billing.subscription.mp_status.paused": "Приостановлено",
                "billing.subscription.mp_status.cancelled": "Отменено",
                "billing.subscription.mp_status.inactive": "Неактивный",
                "billing.subscription.mp_status.unknown": "Незнакомец",
                "billing.unlimited": "Безлимитный",
                "billing.update_plan": "Обновить план",
                "billing.update_plan_modal.title": "Заголовок",
                "billing.usage.loading": "Загрузка",
                "common.accept": "Принимать",
                "common.confirmPassword": "Подтвердите пароль",
                'common.continue': 'Продолжить',
                "common.error": "Ошибка",
                "dashboard.upgrade.to_plan": "Планировать",
                "emoji.noResults": "Нет результатов",
                "emoji.pick": "Выбирать",
                "export.restricted.message": "Сообщение",
                "export.restricted.title": "Заголовок",
                "export.restricted.upgrade": "Обновление",
                "founder.*": "*",
                "help.faq.a1": "А1",
                "help.faq.a2": "А2",
                "help.faq.a3": "А3",
                "help.faq.a4": "А4",
                "help.faq.a5": "А5",
                "help.faq.a6": "А6",
                "help.faq.a7": "А7",
                "help.faq.q1": "1 квартал",
                "help.faq.q2": "2 квартал",
                "help.faq.q3": "3 квартал",
                "help.faq.q4": "4 квартал",
                "help.faq.q5": "Q5",
                "help.faq.q6": "Q6",
                "help.faq.q7": "Q7",
                "help.faq.title": "Заголовок",
                "help.howWorks.step4.point7": "Точка7",
                "help.message_time_context.free_vs_pro": "Бесплатное или профессиональное",
                "help.message_time_context.point5": "Точка5",
                "help.plans.enterprise.benefits": "Преимущества",
                "help.plans.enterprise.description": "Описание",
                "help.plans.enterprise.title": "Заголовок",
                "help.plans.foundation.devices": "Устройства",
                "help.plans.free.description": "Описание",
                "help.plans.free.devices": "Устройства",
                "help.plans.free.limits": "Пределы",
                "help.plans.free.title": "Заголовок",
                "help.plans.intro": "Введение",
                "help.plans.pro.benefits": "Преимущества",
                "help.plans.pro.description": "Описание",
                "help.plans.pro.devices": "Устройства",
                'help.plans.pro.price': '$19 / мес.',
                "help.plans.pro.title": "Заголовок",
                "help.plans.pro.upgrade": "Обновление",
                "help.plans.title": "Заголовок",
                "help.plans.urgent_slots_badge": "Значок срочного слота",
                "help.slogan.final": "Конец",
                "help.suggestions.point1": "Точка1",
                "help.suggestions.point2": "Точка2",
                "help.suggestions.title": "Заголовок",
                "invitation.already_contact_added": "Контакт уже добавлен",
                "invitation.already_contact_title": "Уже связался с заголовком",
                "invitation.already_pending": "Уже на рассмотрении",
                "invitation.language.invalid": "Неверный",
                "message.send": "Отправлять",
                "message.sendFile": "ОтправитьФайл",
                "messages.conversations": "Разговоры",
                "messages.no_conversations_subtitle": "Нет субтитров разговоров",
                "messages.no_conversations_title": "Нет заголовка разговора",
                "presence.custom.edit": "Редактировать",
                "profile.enrichment.country": "страна",
                "profile.enrichment.country.select": "Выбирать",
                "profile.enrichment.description": "Описание",
                "profile.enrichment.org_size": "Размер организации",
                "profile.enrichment.org_size.placeholder": "держатель места",
                "profile.enrichment.save": "Сохранять",
                "profile.enrichment.skip": "пропускать",
                "profile.enrichment.title": "Заголовок",
                "profile.enrichment.usage_type.label": "Этикетка",
                "profile.enrichment.usage_type.placeholder": "держатель места",
                "profile.founderPosition": "Должность основателя",
                "settings.confirmations.description": "Описание",
                "settings.confirmations.disable": "Запрещать",
                "settings.confirmations.title": "Заголовок",
                "settings.confirmations.updated": "Обновлено",
                "settings.title": "Заголовок",
                "theme.description": "Описание",
                "google.unavailable_tenant": "Google недоступен для этого клиента.",
                "google.unavailable": "Гугл недоступен.",
                "google.verify_client_id": "Проверьте идентификатор клиента в Google Cloud Console.",
                'google.login_aria': 'Войти через Google',
                "message.preview_alt": "Предварительный просмотр",
                "message.image_attachment_alt": "Прикрепленное изображение",
                "profile.avatar.alt": "аватар",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "Загрузка лучших приглашенных...",
                "invitation.top.empty": "Пока нет избранных приглашенных.",
                "invitation.contacts.title": "Пригласить контакты",
                "invitation.contacts.safe_phase_note": "Активна безопасная фаза: ожидаемые льготы без влияния на реальные лимиты.",
                "invitation.contacts.generate_code": "Создать код/ссылку",
                "invitation.contacts.refresh_top3": "Обновить топ-3",
                "invitation.contacts.hide_full_ranking": "Скрыть полный рейтинг",
                "invitation.contacts.show_full_ranking": "Показать полный рейтинг",
                "invitation.contacts.hide_metrics_dashboard": "Скрыть панель показателей",
                "invitation.contacts.show_metrics_dashboard": "Показать панель показателей",
                "invitation.contacts.prepared_link_label": "Готовая ссылка:",
                "invitation.contacts.email_placeholder": "электронная почта@domain.com",
                "invitation.contacts.register_pending": "Зарегистрироваться в ожидании приглашения",
                "invitation.contacts.status_summary": "Сводка статуса",
                "invitation.contacts.sent_invitations": "Отправленные приглашения",
                "invitation.contacts.invited_email": "Приглашенное письмо",
                "invitation.contacts.code": "код",
                "invitation.contacts.no_sent_invitations": "Я еще не отправлял приглашения.",
                "invitation.contacts.simulated_rewards": "Получены смоделированные награды",
                "invitation.contacts.no_simulated_rewards": "Имитированных наград пока нет.",
                "common.id": "ИДЕНТИФИКАТОР",
                "common.created": "Созданный",
                'plan.pro_contacts': 'До 100 контактов на пользователя',
                "common.status": "Статус",
                "login.prompt_create_account_with_name": "Вы хотите создать учетную запись с этим именем?",
                'plans.upgrade.title': 'Обновить план',
                'plans.upgrade.comparison': 'Сравнение планов',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'Отмена в любое время',
                'plans.actions.upgrade_pro': 'Перейти на PRO',
                'plans.actions.become_founder': 'Стать Founder',

                'plans.modal.card.current_badge': 'Ваш текущий тариф',

                'plans.modal.card.lower_tier': 'Ниже вашего активного тарифа',

                'plans.modal.card.manage_in_profile': 'Чтобы изменить или отменить: Подписка и оплата в профиле.',
                'plans.modal.card.cancel_subscription': 'Отменить подписку',
                'plans.modal.cancel_confirm.title': 'Отменить или управлять подпиской',
                'plans.modal.cancel_confirm.body': 'Откроется новая вкладка с защищённым порталом Paddle: оплата, счета или отмена подписки.',
                'plans.modal.cancel_confirm.continue_button': 'Продолжить',
                'plans.modal.cancel_confirm.back_button': 'Назад',
                'plans.modal.cancel_paddle_fallback.title': 'Управление подпиской',
                'plans.modal.cancel_paddle_fallback.body': 'Портал Paddle здесь не открывается (например, локально или без привязки счёта). Планы по-прежнему можно просматривать и сравнивать на этом экране.',
                'plans.modal.cancel_paddle_fallback.confirm': 'Понятно',
                'plans.upgrade_required': 'Доступно в тарифе PRO',
                'settings.heading': 'Настройки',
                'settings.dashboard': 'Панель',
                'settings.dashboardDescription': 'Локальные настройки стартовой панели и видимых блоков.',
                'settings.dashboardGridHeading': 'Блоки панели',
                'settings.dashboardShowOnStartDescription': 'Если включено, после входа открывается панель вместо списка контактов.',
                'settings.dashboardBlockWelcome': 'Приветствие',
                'settings.dashboardBlockUsage': 'Использование плана',
                'settings.dashboardBlockFiles': 'Мои файлы',
                'settings.dashboardBlockPromotions': 'Акции',
                'settings.dashboardBlockSessions': 'Сессии',
                'settings.dashboardWelcomeDescription': 'Первые шаги, приглашение контакта и ярлыки справки.',
                'settings.dashboardUsageDescription': 'Использование и лимиты: контакты, символы, хранилище, устройства.',
                'settings.dashboardFilesDescription': 'Сводка по видимым файлам и месту в «Мои файлы».',
                'settings.dashboardPromotionsDescription': 'Сводка акций и ссылка на программу.',
                'settings.dashboardSessionsDescription': 'Активные сессии и устройства; при возможности — закрыть другие сессии.',
                'settings.enabled': 'Вкл.',
                'settings.disabled': 'Выкл.',
                'settings.showDashboardOnStart': 'Показывать панель при входе',
                'settings.showWelcomeBlock': 'Показать приветствие',
                'settings.showPromotionsBlock': 'Показать акции',
                'settings.showUsageBlock': 'Показать использование плана',
                'settings.showRecentConversationsBlock': 'Показать недавние беседы (последнее сообщение на контакт)',
                'settings.showSessionsBlock': 'Показать сессии',
                'settings.showFilesBlock': 'Показать сводку файлов',
                'settings.dashboardLocalNote': 'Параметры хранятся в этом браузере (локально) до API профиля.',
                'settings.appearanceSettings': 'Оформление',
                'settings.argentinaTheme': 'Тема Аргентина',
                'settings.darkMode': 'Тёмная тема',
                'settings.language': 'Язык',
                'settings.messageSound': 'Звук сообщений',
                'settings.playSoundDescription': 'Воспроизводить звук при новых сообщениях или важных уведомлениях.',
                'settings.messageSoundEnabled': 'Вкл.',
                'settings.messageSoundDisabled': 'Выкл.',
                'settings.accountSettings': 'Аккаунт',
                'settings.deleteAccount': 'Удалить аккаунт',
                'settings.deleteAccountWarning': 'Это действие окончательное. Ваши данные, сообщения, контакты и настройки будут удалены в соответствии с процессом платформы.',
                'settings.deleteMyAccount': 'Удалить мой аккаунт',
                'dashboard.contacts': 'Контакты',
                'dashboard.characters': 'Символы',
                'dashboard.storage': 'Хранилище',
                'dashboard.active_devices': 'Активные устройства',
                'dashboard.need_more_resources': 'Нужно больше ресурсов?',
                'dashboard.upgrade_message': 'Обновите план, чтобы получить больше контактов, символов, хранилища и активных устройств.',
                'dashboard.upgrade_button': 'Перейти на PRO',
                'dashboard.upgrade_button_pro': 'Перейти на PRO',
                'dashboard.upgrade_button_foundation': 'Перейти на FOUNDATION',
                'files.preview': 'Просмотр',
                'files.previewFile': 'Просмотр файла',
                'files.previewUnavailable': 'Предпросмотр недоступен.',
                'files.previewLoading': 'Загрузка предпросмотра…',
                'files.openPreview': 'Предпросмотр',
                'files.downloadFile': 'Скачать файл',
                'files.downloadFailed': 'Не удалось скачать файл. Проверьте соединение и сессию и повторите попытку.',
                'files.closePreview': 'Закрыть предпросмотр',
                'files.unsupportedPreview': 'Предпросмотр для этого типа файла недоступен. Можно посмотреть сведения или скачать.',
                'files.pdfPreviewHelp': 'Браузер может не показать встроенный PDF. Скачайте файл, чтобы открыть.',
                'files.labelFileType': 'Тип',
                'files.previewForbidden': 'Нет права на предпросмотр.',
                'files.previewNotFound': 'Файл недоступен или больше не отображается в аккаунте.',
                'files.unavailableForFree': 'Раздел «Мои файлы» не входит в тариф FREE.',
                'files.availableInFoundationAndPro': 'Раздел «Мои файлы» доступен в тарифах FOUNDATION и PRO.',
                'files.filesFeatureRestricted': 'Эта функция недоступна на вашем текущем тарифе.',
                'files.filesLoadError': 'Ошибка загрузки файлов.',
                'files.uploadUnavailableForFree': 'Отправка файлов недоступна в FREE.',
                'files.uploadAvailableInFoundationAndPro': 'Отправка файлов доступна в FOUNDATION и PRO.',
                'files.recipientStorageFull': 'У получателя нет свободного места для этого файла.',
                'files.recipientNoAvailableStorage': 'У получателя нет свободного места для этого файла.',
                'files.storageQuotaExceeded': 'Достигнут лимит хранилища вашего тарифа.',
                'files.freeStorageLimit': 'В FREE включено 5 МБ для полученных файлов.',
                'settings.unreadEmailReminderSection': 'Сводка непрочитанного по email',
                'settings.unreadEmailReminderDescription': 'Если новые сообщения или файлы остаются непрочитанными дольше указанного времени, ArChat отправляет одно сводное письмо (не по одному на сообщение).',
                'settings.unreadEmailReminderToggle': 'Присылать сводки на email',
                'settings.unreadEmailDelayHours': 'Задержка перед отправкой (часы)',
                'settings.unreadEmailDelayHint': '1–168 часов (до недели). Язык письма — из профиля.',
                'subjects.title': 'Темы',
                'subjects.singular': 'Тема',
                'subjects.plural': 'Темы',
                'subjects.general': 'Общее',
                'subjects.new': 'Новая тема',
                'subjects.create': 'Создать тему',
                'subjects.rename': 'Переименовать',
                'subjects.finish': 'Завершить',
                'subjects.reopen': 'Открыть снова',
                'subjects.select': 'Продолжить',
                'subjects.status.open': 'Открыта',
                'subjects.status.pending': 'В ожидании',
                'subjects.status.finished': 'Завершена',
                'subjects.limitReached': 'Достигнут лимит активных тем в этом чате. Завершите тему, чтобы создать новую.',
                'subjects.limitReachedFree': 'Тариф FREE: до 3 активных тем на чат. Завершите тему, чтобы создать новую.',
                'subjects.limitReachedPro': 'Тариф PRO: до 5 активных тем на чат. Завершите тему, чтобы создать новую.',
                'subjects.limitReachedFoundation': 'Тариф FOUNDATION: до 5 активных тем на чат. Завершите тему, чтобы создать новую.',
                'subjects.activeLimitsLine': 'Активные темы: {current} / {max}',
                'subjects.closedListTitle': 'Закрытые темы',
                'subjects.viewClosed': 'Просмотреть закрытые темы',
                'subjects.noClosedSubjects': 'Закрытых тем нет.',
                'subjects.reopenSubject': 'Открыть снова',
                'subjects.reopenedSubjects': 'Повторно открытые темы',
                "subjects.reopenLimitReached": `subject.ownerOnlyReopen': 'Повторно открыть ее может только тот, кто создал тему.`,
                'subjects.ownerOnlyReopen': 'Только создавший тему пользователь может открыть её снова.',
                'subjects.modal.title': 'Темы чата',
                'subjects.modal.subtitle': 'Выберите или управляйте темами этого чата.',
                'subjects.contactLabel': 'КОНТАКТ:',
                'subjects.ownerOnlyRename': 'Переименовать тему может только её создатель.',
                'subjects.ownerOnlyStateChange': 'Изменить статус темы может только её создатель.',
                'subjects.createdByOther': 'Эту тему создала другая сторона. Вы можете отвечать, но не переименовывать её.',
                'subjects.empty': 'Нет тем для отображения.',
                'subjects.noResults': 'Темы не найдены.',
                'subjects.error.generic': 'Не удалось выполнить действие. Попробуйте снова.',
                'subjects.error.featureDisabled': 'Темы недоступны в этой среде.',
                'subjects.error.duplicateName': 'Активная тема с таким названием уже существует.',
                'subjects.error.ownerRequired': 'У вас нет прав изменять эту тему.',
                'subjects.error.defaultCannotRename': 'Тему «Общее» нельзя переименовать.',
                'subjects.error.defaultCannotFinish': 'Тему «Общее» нельзя завершить.',
                'subjects.current': 'Тема',
                'subjects.change': 'Сменить тему',
                'subjects.currentLabel': 'Тема:',
                'subjects.changeSubject': 'Сменить тему',
                'subjects.closedCannotSend': 'Эта тема завершена. Откройте её снова, чтобы отправлять сообщения.',
                'subjects.selectBeforeSend': 'Выберите тему в окне, чтобы просмотреть сообщения и отправлять.',
                'subjects.loadingMessages': 'Загрузка сообщений для этой темы…',
                'subjects.messageFilterError': 'Не удалось загрузить сообщения для этой темы.',

                // Tags
                "tags.etiquetas": "теги",
                "tags.manageTitle": "Управление тегами",
                "tags.manage": "🏷️ Теги",
                "tags.allTags": "Все теги",
                "tags.confirmDelete": "Удалить этот тег?",
                "tags.tagNamePlaceholder": "Имя тега",
                "tags.create": "Создавать",
                "tags.noTags": "Никаких тегов. Создайте один выше.",
                "tags.save": "Сохранять",
                "tags.edit": "Редактировать",
                "tags.delete": "Удалить",
                "tags.assignTo": "Назначить",
                "tags.noTagsToAssign": "Нет доступных тегов. Сначала создайте их.",
                // Templates
                "templates.selectTitle": "Шаблоны",
                "templates.noTemplates": "Никаких шаблонов. Создайте один выше.",
                "templates.manage": "Управление шаблонами",
                "templates.confirmDelete": "Удалить этот шаблон?",
                "templates.manageTitle": "Управление шаблонами",
                "templates.titlePlaceholder": "Название шаблона",
                "templates.bodyPlaceholder": "Напишите шаблонное сообщение...",
                "templates.create": "Создать шаблон",
                "templates.save": "Сохранять",
                "templates.edit": "Редактировать",
                "templates.delete": "Удалить",
                // Tags (added)
                "tags.bgColor": "Цвет фона",
                "tags.textColor": "Цвет текста",
                "tags.selectTag": "Выберите тег",
                // Web Push notifications
                "settings.webPushSection": "Системные уведомления (Web Push/PWA)",
                "settings.webPushDescription": "Позволяет получать оповещения, когда приложение находится в фоновом режиме или закрыто на мобильном устройстве. В сборке требуется открытый ключ VAPID (VITE_VAPID_PUBLIC_KEY) и ключи сервера. Предоставляет разрешение браузеру и регистрирует это устройство.",
                "settings.webPushButton": "Включить push-уведомления",
                "settings.webPushRegistering": "Регистрация…",
                "settings.webPushState.granted": "Разрешение получено. Если настроен VAPID, подписка была отправлена ​​на сервер.",
                "settings.webPushState.denied": "Доступ запрещен. Включите уведомления для этого сайта в настройках браузера.",
                "settings.webPushState.default": "Нажмите кнопку, чтобы запросить разрешение и зарегистрировать это устройство.",
                "settings.webPushState.unsupported": "Этот браузер не поддерживает Web Push.",
                "settings.webPushVapidMissing": "В этой сборке внешнего интерфейса отсутствует VITE_VAPID_PUBLIC_KEY: принудительная подписка не может быть завершена.",
                ...PRESET_LOCALES.ru,
                "auth.login.clear_password_lock_after_reset": "Я уже изменил свой пароль (например, на другом устройстве)",
                "auth.signup_disabled": "Регистрация новой учетной записи временно отключена в этой среде.",
                "auth.reset_user_not_found": "Мы не нашли учетную запись, связанную с этим электронным письмом. Проверьте правильность написания или создайте новую учетную запись.",
                "account.not_found": "Аккаунт не найден.",
                "auth.pending_activation.title": "Аккаунт ожидает активации",
                "auth.pending_activation.body": "Ваша учетная запись еще не активирована. Проверьте свою электронную почту и подтвердите регистрацию для входа в ArChat.",
                "auth.pending_activation.back_to_login": "Вернуться к входу",
                "auth.pending_activation.support_prefix": "Вам нужна помощь? Свяжитесь со службой поддержки:",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "Электронная почта для повторной активации",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "Введите адрес электронной почты, под которым вы регистрировались, чтобы повторно отправить активацию.",
                "auth.pending_activation.sent_title": "Письмо с активацией отправлено",
                "auth.pending_activation.sent_body": "Если адрес электронной почты соответствует ожидающей учетной записи, мы вышлем вам новую ссылку для активации. Проверьте свой почтовый ящик, а также спам или нежелательную почту.",
                "auth.pending_activation.soft_error_title": "Повторная отправка недоступна",
                "auth.pending_activation.soft_error_body": "В настоящее время нам не удалось обработать повторную отправку. Попробуйте еще раз через несколько минут или напишите нам по адресу info@archat.com.ar.",
                "auth.pending_activation.resend_again": "Отправить еще раз",
                "menu.plans": "Планы",
                "files.title": "мои файлы",
                "files.filter_all": "Все",
                "files.filter_sent": "Отправил",
                "files.filter_received": "Полученный",
                "files.filter_images": "Изображения",
                "files.filter_documents": "Документы",
                "files.col_name": "Имя",
                "files.col_size": "Размер",
                "files.col_date": "Дата",
                "files.col_direction": "Реж.",
                "files.col_actions": "Действия",
                "files.sent": "📤 Отправлено",
                "files.received": "📥 Получено",
                "files.download": "Увольнять",
                "files.delete_for_me": "Удалить для меня",
                "files.delete_confirm_title": "Удалить файл",
                "files.delete_confirm_message": "Этот файл будет удален из вашей учетной записи. Он не будет удален для другого человека. Продолжать?",
                "files.empty": "У вас нет файлов.",
                "files.error_loading": "Ошибка загрузки файлов.",
                "files.load_more": "Загрузить больше",
                "message.status.sending": "Отправка…",
                "message.status.failed": "Не отправлено",
                "message.status.sent": "Отправил",
                "message.status.delivered": "Доставленный",
                "message.status.read": "Читать",
                "home.public_nav.pricing": "Цены",
                "home.public_nav.aria": "Основная навигация по сайту",
                "home.public_footer.aria": "Юридические ссылки",
                "home.pricing_link": "Планы и цены",
                "publicPricing.nav.back_home": "← Главная",
                "publicPricing.title": "Планы и цены",
                "publicPricing.subtitle": "Прозрачные и согласованные ограничения для механизма подписки ArChat. Коммерческие цены в долларах США для международной оплаты (например, Paddle).",
                "publicPricing.commercial_note": "Функциональные границы берутся из PlanConstants/PlanResolver; ваша учетная запись может применять plan_limits в базе данных. Взимание платы с торговцев использует Paddle (или другие процессоры, официально назначенные ArChat) с указанными ценами в долларах США.",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "Те же технические ограничения, что и у PRO (премиум-контракт).",
                "publicPricing.same_limits_foundation": "Те же технические ограничения, что и у FOUNDATION (премиальный контракт).",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "30 000 символов в месяц на аккаунт.",
                "publicPricing.free.b2": "До 2 контактов на пользователя; до 2 активных разговоров на аккаунт.",
                "publicPricing.free.b3": "Никаких вложений и места для хранения; без экспорта данных.",
                "publicPricing.free.b4": "История сообщений до 30 дней; 1 устройство на пользователя.",
                "publicPricing.free.b5": "34 сообщения/день и 1000 сообщений/месяц (арендатор); до 20 приглашений в день.",
                "publicPricing.premium.b1": "300 000 символов в месяц на аккаунт; до 100 контактов на пользователя.",
                "publicPricing.premium.b2": "Безлимитное общение и чаты (арендатор); 1667 сообщений в день и 50 000 в месяц.",
                "publicPricing.premium.b3": "До 50 МБ хранилища (арендатор); до 3 устройств на пользователя.",
                "publicPricing.premium.b4": "Безлимитные приглашения (арендатор); экспорт, автоматический перевод и файлы по плану.",
                "publicPricing.premium.b5": "FOUNDATION: тот же технический контракт, что и PRO, плюс программа Founder (150 мест). PRO: премиум-стандарт.",
                "publicPricing.foundation.founder_note": "Коммерческая программа Founder: ограниченное количество мест {slots} (см. сводку плана). Те же ограничения PRO после активации подписки.",
                "publicPricing.cta.start_free": "Создать бесплатную учетную запись",
                "publicPricing.cta.register_paid": "Зарегистрироваться",
                "publicPricing.paddle_hint": "Оформление заказа с выбранным процессором будет завершено в приложении при включении зарядки.",
                "publicPricing.legal.nav_label": "Юридический",
                "publicPricing.legal.terms": "Условия обслуживания",
                "publicPricing.legal.privacy": "политика конфиденциальности",
                "publicPricing.legal.refund": "Политика возврата",
                "profile.security.privacy_note": "Управляйте конфиденциальностью и безопасностью своей учетной записи.",
                "profile.security.sessions_title": "Активные сессии",
                "profile.security.current": "Текущая сессия",
                "profile.plan.foundation.description": "План FOUNDATION (Founder): такое же премиум-использование, как и PRO, с программой Founder и ограниченным пространством (150 мест).",
                "billing.view_plans": "Посмотреть планы",
                "billing.paddle.cancel_via_portal": "Отменить подписку",
                "billing.paddle.test_access_denied_body": "На этом сервере ограничены операции биллинга (тестовый режим или тестовый список). Если вы уже заплатили с реальной учетной записи, в рабочей среде платеж должен быть разрешен для всех пользователей (например, PAYMENTS_ALLOW_ALL_BILLING_USERS) или это ограничение должно быть отключено. Свяжитесь со службой поддержки.",
                "attachment.storage_insufficient_precheck.title": "Недостаточно места",
                "attachment.storage_insufficient_precheck.message": "Файл весит {fileSizeMb} МБ, а у вас доступно только {availableMb} МБ. Освободите место или улучшите свой план, чтобы продолжить.",
                "attachment.files_disabled.title": "Лимит плана",
                "attachment.files_disabled.message": "Ваш текущий план не включает отправку файлов. Улучшите свой план, чтобы продолжить.",
                "contacts.viewContactInfo": "Посмотреть контактную информацию",
                "contacts.contactInfoTitle": "Контактные данные",
                "contacts.phone": "Телефон",
                "contacts.bio": "Биография",
                "contacts.notProvided": "Неосведомленный",
                "contacts.unread.badge": "Непрочитанные сообщения",
                "dashboard.recentInbound.title": "Последние полученные сообщения",
                "dashboard.recentInbound.empty": "У вас нет последних полученных сообщений.",
                "dashboard.recentInbound.error": "Не удалось загрузить сообщения.",
                "dashboard.recentInbound.previewPhoto": "Фото",
                "dashboard.recentInbound.previewFile": "Архив",
                "dashboard.recentInbound.previewPdf": "PDF",
                "dashboard.recentInbound.previewUnavailable": "Сообщение недоступно",
                "dashboard.recentInbound.readTitle": "Читать",
                "dashboard.recentInbound.unreadTitle": "непрочитанный",
                "dashboard.recentConversations.title": "Недавние разговоры",
                "dashboard.recentConversations.empty": "Нет диалогов, которые можно было бы показать.",
                "dashboard.recentConversations.error": "Не удалось загрузить беседы.",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "Перевод недоступен",
                "plan.errors.translationNotAllowed.message": "Ваш текущий план не включает автоматический перевод между языками.",
                "plan.errors.translationNotAllowed.solution": "Чтобы использовать автоматический перевод, обновите свой план.",
                "billing.subscription.cancel_scheduled_date": "Ваша подписка будет отменена {{date}}. До тех пор вы можете продолжать использовать свой план.",
                "billing.subscription.cancel_scheduled_badge": "Отменено {{date}}",
                "billing.scheduled.plan_after_cancel_label": "План на конец периода:",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "Перейти на ФУНДАМЕНТ",
                "billing.scheduled.switch_to_free": "Перейти на БЕСПЛАТНО",
                "billing.scheduled.foundation_full_title": "ФУНДАМЕНТ недоступен",
                "billing.scheduled.foundation_full_message": "В настоящее время свободных мест FOUNDATION нет. В конце периода ваш план станет БЕСПЛАТНЫМ.",
                "billing.scheduled.saving": "Сохранение...",
                "billing.scheduled.error_title": "Ошибка при смене плана",
                "billing.scheduled.error_generic": "Запланированный план изменить невозможно. Попробуйте еще раз.",
                "billing.cancel_scheduled.title": "Запланированная отмена",
                "billing.cancel_scheduled.desc": "Ваша подписка будет отменена {{date}}. До тех пор вы можете продолжать использовать свой текущий план.",
                "billing.cancel_scheduled.no_new_plan_until_end": "До истечения срока действия этой подписки вы не сможете заключить контракт на другой план.",
                "billing.cancel_scheduled.free_fallback": "Если вы не продлите какой-либо план, ваша учетная запись продолжит действовать БЕСПЛАТНО с соответствующими ограничениями.",
                "billing.cancel_scheduled.profile_deactivation_hint": "Вы также можете отказаться от подписки на платформу в своем профиле.",
                "billing.cancel_scheduled.default_free": "В конце периода: БЕСПЛАТНО",
                "google.missing_client_id": "Вход в Google недоступен в этой сборке: VITE_GOOGLE_CLIENT_ID (или googleClientId для каждого клиента в __ARCHAT_TENANT_CONFIG__) отсутствует.",
                "reviews.title": "АрЧат Отзывы",
                "reviews.create_title": "Как бы вы оценили АрЧат?",
                "reviews.edit_title": "Редактировать мой отзыв",
                "reviews.comment_placeholder": "Расскажите нам о своем опыте (по желанию)...",
                "reviews.submit_btn": "Отправить отзыв",
                "reviews.update_btn": "Обновлять",
                "reviews.thank_you": "Спасибо за ваш обзор!",
                "reviews.submitted_message": "Ваше мнение помогает нам совершенствоваться.",
                "reviews.error_select_rating": "Выберите рейтинг",
                "reviews.error_generic": "Ошибка при отправке отзыва.",
                "reviews.prompt_message": "Вам нравится АрЧат? Оставьте свой отзыв!",
                "reviews.rate_now": "Квалифицироваться",
                "reviews.later": "Позже",
                "reviews.write_review": "Написать отзыв",
                "reviews.edit_my_review": "Редактировать мой отзыв",
                "reviews.no_reviews": "Пока нет отзывов. Будь первым!",
                "reviews.review_singular": "обзор",
                "reviews.review_plural": "обзоры",
                "reviews.verified": "Проверено",
                "reviews.anonymous": "Анонимный",
                "files.storageUsed": "Используемое пространство",
                "files.planQuota": "Плановая квота",
                "files.availableStorage": "Доступный",
                "files.usagePercent": "использовал",
                "files.unlimited": "Безлимитный",
                "files.sentBy": "Отправлено",
                "files.unknownUser": "Пользователь",
};


